import { Route } from '@angular/compiler/src/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { FieldMapPipe } from 'src/app/pipe/fieldMap.pipe';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { RouteService } from 'src/app/Services/route.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const animateValue: any;
declare const Swal;

@Component({
  selector: 'app-create-regular-route',
  templateUrl: './createRoute.component.html',
  styleUrls: ['./createRoute.component.css']
})



export class CreateRouteComponent implements OnInit {
  /* Route variables */
  public enableRouteExlDownload: boolean = false;
  activePanel: string = 'Route';//'PickupPoint';
  routeID: any = '';
  public routeType: string = '';
  componentToggle: boolean = true;
  public disableBuildType: boolean = false;
  public showRouteForm: boolean = false;     //Expand panel route form show
  public routeEdit = false;
  public formExpand = true;
  public formColumnExpand = false;
  public titleBarTitle = 'Create Route';

  /* Form variables */
  matFormSize = '13px';
  status: string = 'Active';
  isEditedActive = [];
  selectedKeywords = [];   // keyword field value
  attendanceType = new FormControl(); //atte
  public formObject: any = {
    buildType: '',
    title: '',
    fromDate: '',
    startTime: '',
    endTime: '',
    trasitMode: '',
    attendence: '',
    keywords: [],
    holidayPattern: [],
    notification: [],
    isEnable: '',
    routeType: '',
    routePpRadius: '',
    safeDrop: true,
  };
  public errorObject = JSON.parse(JSON.stringify(this.formObject));
  public updateValues = [];
  //Date
  defaultSDate: string = '';
  defaultEDate: string = '';
  public minDate: any = new Date();
  public minFromDate: any = new Date();
  public toDateLabel = 'To Date';
  //Button
  public submitBtnPressed: boolean = false;

  /* API Data */
  vehicleListObject: any = {};        //vehicle data
  public allVehicles: any = {};       //all vehicle data
  public routeData = {};              //Route data
  public pickupPoints = [];           //Pickup points Data
  public shiftInformation: any = [];   //shift data
  public branchInformation: any = [];  //branch data

  /* Form Field Option variables */
  attendanceList: string[] = ['Beacon', 'OTP', 'QR', 'RFID'];
  public disableShiftField: boolean = true;
  public editVehicleOption: any = [];
  public optionTitlecase: boolean = false;

  /* Branch field */
  public branchlists: any = [];
  public selectedBranch = [];
  @ViewChild('branchSearch') branchSearchTextBox: ElementRef;
  branchSearchChangeObserver: any;
  public showBranchField: boolean = false;
  public branchSearchVal: any = '';

  /* Shift field */
  public shiftlists: any = [];
  public selectedShift: any = [];
  @ViewChild('shiftSearch') shiftSearchTextBox: ElementRef;
  shiftSearchChangeObserver: any;
  public showShiftField: boolean = false;
  public shiftSearchVal: any = '';

  /* holiday field */
  public holidaylists = [];
  public selectedHoliday: any = [];
  @ViewChild('holidaySearch') holidaySearchTextBox: ElementRef;
  holidaySearchChangeObserver: any;
  public showHolidayField: boolean = false;
  public holidaySearchVal: any = '';

  /* vehicle field */
  public vehiclelists: any = [];
  public selectedVehicle: any = [];
  @ViewChild('vehicleSearch') vehicleSearchTextBox: ElementRef;
  vehicleSearchChangeObserver: any;
  public disableVehicleField: boolean = true;
  public showVehicleField: boolean = false;
  public vehicleSearchVal: any = '';

  /* Booking field */
  public enableDaysCount: boolean = false;


  /* Employee selection Modal */
  public getSelectedEmpList: any = {};
  //close
  public closePopup: boolean = true;
  /* Start & End Location modal */
  public stEndLocVehRegNo = '';
  public closeStEndLocPopup = true;
  public selectedStEndLoc = {};
  public stEndLocData: any = {};
  public selectedTripLocId: any;
  public stEndLocModalTitle = '';
  public selectedLocType = '';
  public editStEndLocation: boolean = false;

  /* Vehicle Table */
  public vehicleTableData = [];
  public automaticVehTableData = [];
  // vehicle excel variable
  public excelData: any = {};

  /* Automation Route variables */
  public vehStartEndLoc = {};
  public createAutoRoute: boolean = false;
  public enableAddEmployee: boolean = false;
  public unassingedEmps = [];
  public unassignedVehicles = [];
  public AssignedEmpList: any = {};
  public automaticPickupInfo: any;
  public automaticSelectedEmps: any = {};
  // Expansion panel
  public empPanelShow: boolean = false;
  public vehPanelShow: boolean = false;
  public empPanelExpand: boolean = false;
  public vehPanelExpand: boolean = false;
  public unassignEmpPanelExpand: boolean = false;
  // Employee count & vehicle seat count for generate route
  public allVehHavLoc: boolean = false;
  public selectedEmpCounts = 0;
  public selectedFemaleEmpCounts = 0;
  public selectedVehicleCounts = 0;
  public selectedVehicleSeats = 0;
  public getSafeDrop: boolean = false;
  public safeDrop: boolean = false;
  // Route Generate popup conditions
  public addMoreVehicle: boolean = false;
  public addVehicle: boolean = false;
  public addVehicleEmployeeList = [];
  public addVehicleList = [];
  public generateBtnClicked: boolean = false;
  @ViewChild('startTime') startTimeInput!: ElementRef;

  /* Manage pickup point */
  public selectedVeh: string = '';
  public enableGSearch: boolean = true;

  /* Progress Bar */
  public closeProgressBar: boolean = false;
  public progressBarMsg = 'pickup points creating';
  public processValue = 0;
  public showProgress: boolean = false;

  /* common method variable */
  public objKeys = Object.keys;

  /* Field Mapping */
  public mappingField: any = {};
  generalSetting: boolean = false;

  constructor(
    private api: ApiService,
    private swal: SweetAlert,
    private route: ActivatedRoute,
    private comservice: CommonServices,
    private routeservice: RouteService,
    private loader: LoaderService,
    private storage: StorageService,
    public router: Router,
    private share: SharedService,
    public excel: ExcelExportService,
    private fieldMap: FieldMapPipe
  ) {
    let userInfo = this.storage.get('userInfo');
    if (userInfo?.general?.event == true) this.generalSetting = true;

    if (userInfo.mappingField) this.mappingField = userInfo.mappingField;

    if (this.router.url.includes('edit-route')) this.titleBarTitle = 'Edit Route';
    this.route.paramMap.subscribe(params => {
      this.routeID = params.get('id');
      this.routeType = params.get('routeType');
      let veh = params.get('regNo');

      // if(params.get('gMap') && params.get('gMap')=='g') this.enableGSearch = true;
      // else this.enableGSearch = false;

      if (this.routeID) {
        this.formExpand = false;
        this.enableAddEmployee = true;
        this.disableBuildType = true;
        this.routeEdit = true;
        this.getSelectedRoute();
      }

      if (this.routeType == 'occasional') {
        this.formObject.buildType = 'Manual';
        this.disableBuildType = true;
        // this.formObject['toDate'] = '';
        
        if (this.generalSetting == true) {
          
          this.formObject['vehicle'] = [];
          this.formObject['toDate'] = new Date();
          this.formObject['fromDate'] = new Date();
          this.formObject['toDate'].setHours(0, 0, 0, 0);
          this.formObject['fromDate'].setHours(0, 0, 0, 0);
          this.dateResult(this.formObject['toDate'], 'date', 'toDate');
          this.dateResult(this.formObject['fromDate'], 'date', 'fromDate');
          this.formObject.trasitMode = 'Pickup';
      
            const currentDate = new Date();
            const hours = currentDate.getHours().toString().padStart(2, '0');
            const minutes = currentDate.getMinutes().toString().padStart(2, '0');
            this.formObject.startTime = `${hours}:${minutes}`;
          // this.formObject.startTime = '00:01';
          // this.formObject.endTime = '23:59';
          this.formObject.routePpRadius = 1;
          this.fieldChange(this.formObject.routePpRadius, 'text', 'routePpRadius');
          this.timeValidation({ target: { value: this.formObject.startTime}}, 'startTime');
          // this.timeValidation(this.formObject.endTime, 'endTime');
          this.attendanceType = new FormControl(['RFID']);
          this.formObject.attendence = this.attendanceType.value;
          this.attendanceChange(this.formObject.attendence);
          this.formObject.notification = ['push'];
          this.fieldChange(this.formObject.notification, 'dropdown', 'notification');
        }
        else { this.formObject['toDate'] = '';
          this.formObject['vehicle'] = [];
          this.toDateLabel = 'To Date *'; }
      }
      if (this.routeType == 'openBooking') {
        this.formObject.buildType = 'Manual';
        this.disableBuildType = true;
        this.formObject['branch'] = '';
        this.formObject['shift'] = '';
        this.formObject['vehicle'] = [];
        this.formObject['blockDuration'] = '';
        this.formObject['bookingDays'] = 'single';
        this.formObject['dayCount'] = 1;
        this.attendanceList.push('Not Required');
      }
      this.getBranchList();
      this.getListShift();
      this.getHolidayList();

      if (veh != '0' && veh != undefined && veh != null) {
        this.getVehicleData(veh);
        setTimeout(() => {
          this.managePickupPoint(veh);
        }, 1000);
      }

    });

    this.share._subject.subscribe((e: any) => {
      if (e.type == 'routeGenProg') {
        this.processValue = e.data;
        this.progressBarMsg = e.msg;
      }
    })
  }

  ngOnInit(): void {
    this.formObject.isEnable = "1";
  }

  /* API Calls */
  //shift
  getListShift(name?, shift?) {
    this.showShiftField = false;
    this.shiftlists = [];
    const obj = {};
    if (name) obj['shiftName'] = name;

    if (shift && shift != '') obj['shiftID'] = [shift];

    this.api.ListShift(obj).then((res: any) => {
      if (res.status == 'success') {
        this.shiftInformation = res.data;
        if (this.formObject.branch) {
          if (shift && shift != '') this.getShiftFieldData(this.formObject.branch, shift);
          else this.getShiftFieldData(this.formObject.branch);
        }
        this.showShiftField = true;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  //branch
  getBranchList(name?, branch?) {
    this.showBranchField = false;
    this.branchlists = [];
    const obj = {};
    if (name) obj['branchName'] = name;
    if (branch && branch != '') obj['branchID'] = [branch];

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.branchInformation = res.data;
        res.data.map(item => {
          try {
            if (item.branchName && item.branchID) {
              let branchObj = {
                name: item.branchName,
                value: item.branchID,
              };
              this.branchlists.push(branchObj);
              if (branch && branch.includes(branchObj.value)) this.selectedBranch = [branchObj];
            }
          } catch (err) {
            console.log('branch', err);
          }
        });
        setTimeout(() => {
          this.clearDuplicates('selectedBranch', 'branchlists', 'showBranchField');
          this.showBranchField = true;
        }, 100);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  // Holiday
  getHolidayList(search?, selected?) {
    this.showHolidayField = false;
    const obj = {};
    if (search) obj['search'] = search;
    if (selected && selected != '') obj['title'] = selected;
    this.holidaylists = [];
    this.api.getHolidays(obj).then((res: any) => {
      if (res.status == 'success') {
        Object.keys(res.data).filter((item) => {
          Object.keys(res.data[item]).filter((holiday) => {
            try {
              let holidayObj = {
                name: holiday,
                value: holiday,
                badge: item == 'date' ? 'D' : 'W',
                badgeColor: 'light'
              };
              this.holidaylists.push(holidayObj);
              if (selected && selected.includes(holidayObj.value)) {
                if (this.selectedHoliday.findIndex((item) => item.value == holidayObj.value) == -1) {
                  this.selectedHoliday.push(holidayObj);
                }
              }
            } catch (err) {
              console.log('Holiday', err);
            }
          })
        });
      }
      setTimeout(() => {
        this.clearDuplicates('selectedHoliday', 'holidaylists', 'showHolidayField');
        this.showHolidayField = true;
      }, 100);

    }).catch((err) => {
      this.showHolidayField = true;
      console.log(err);
    });
  }

  getVehicleData(vehicle?) {
    let obj = {};
    this.vehiclelists = [];
    if (vehicle && vehicle) obj['vehRegNo'] = vehicle;
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        try {
          this.vehiclelists = res.data.map(item => {

            let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '---';

            const name = item.vehRegNo.toUpperCase() + ' ' + model;

            this.vehicleListObject[item.vehRegNo] = { name, ...item };
            if (this.allVehicles[item.vehRegNo] == undefined) this.allVehicles[item.vehRegNo] = {};
            this.allVehicles[item.vehRegNo] = item;

            let obj = {
              "name": item.vehRegNo.toUpperCase() + ' ' + model, value: item.vehRegNo,
            }
            if (item['capacity']) {
              obj['badge'] = item['capacity'],
                obj['badgeColor'] = 'light';
            }
            if (vehicle && vehicle.includes(obj.value)) {
              if (this.selectedVehicle.findIndex((item) => item.value == obj.value) == -1) {
                this.selectedVehicle.push(obj);
              }
            }
            return obj;
          });
        } catch (err) {
          console.log(err);
        }

      }
      setTimeout(() => { this.clearDuplicates('selectedVehicle', 'vehiclelists', 'showVehicleField'); this.showVehicleField = true; }, 200);
    }).catch((err) => {
      console.log(err);
    });
  }
  // Vehicle List
  getVehicleList(CB: any) {
    this.api.transportManagerVehicleList({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehiclelists = [];
        if (this.routeID) {
          this.vehiclelists = res.data.map(item => {

            let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '---';

            const name = item.vehRegNo.toUpperCase() + ' ' + model;

            this.vehicleListObject[item.vehRegNo] = { name, ...item };
            if (this.allVehicles[item.vehRegNo] == undefined) this.allVehicles[item.vehRegNo] = {};
            this.allVehicles[item.vehRegNo] = item;

            let obj = {
              "name": item.vehRegNo.toUpperCase() + ' ' + model, value: item.vehRegNo,
            }

            if (item['capacity']) {
              obj['badge'] = item['capacity'],
                obj['badgeColor'] = 'light';
            }

            return obj;
          });
          this.getSelectedRoute();
        } else {
          res.data.map(item => {
            const name = item.vehRegNo.toUpperCase() + ' ' + item.model;
            if (this.allVehicles[item.vehRegNo] == undefined) this.allVehicles[item.vehRegNo] = {};
            this.allVehicles[item.vehRegNo] = item;
          });
        }

        if (CB) CB();
      }
    })
  }
  // Route Data
  getSelectedRoute() {

    let apiMethod = 'transportMangerRouteList';
    // if(this.routeType == 'openBooking') apiMethod = 'transportManagerOpenBookingRouteList';

    this.api[apiMethod]({ routeID: this.routeID }).then((res: any) => {
      if (res.status == 'success') {
        this.routeData = { ...res.data[0] };
        this.selectedKeywords = res.data[0].keywords.map((key) => {
          return { name: key };
        });
        this.defaultSDate = this.comservice.timestampToDate(res.data[0].fromDate, 'YMD', '-');
        if (this.routeType == 'occasional') this.defaultEDate = this.comservice.timestampToDate(res.data[0].toDate, 'YMD', '-');
        this.minDate = new Date(res.data[0].fromDate);
        // this.minFromDate = new Date(res.data[0].fromDate);
        let stime = ('' + res.data[0].startTime).split('.');
        let etime = ('' + res.data[0].endTime).split('.');
        this.formObject = {
          title: res.data[0].title,
          trasitMode: res.data[0].trasitMode,
          attendence: typeof res.data[0].attendence == 'string' ? res.data[0].attendence.split(',') : res.data[0].attendence,
          startTime: this.getTimeString(res.data[0].startTimeStr),
          endTime: this.getTimeString(res.data[0].endTimeStr),
          routeType: res.data[0].routeType,
          keywords: res.data[0].keywords,
          holidayPattern: res.data[0].holidayPattern,
          notification: res.data[0] && res.data[0].notification ? Object.keys(res.data[0].notification) : [],
          orgID: res.data[0].orgID,
          routeID: res.data[0].routeID,
          isEnable: '' + res.data[0].isEnable,
          routePpRadius: res.data[0].routePpRadius ? res.data[0].routePpRadius : 0,
          fromDate: res.data[0].fromDate ? new Date(res.data[0].fromDate) : '',
          vehicle: res.data[0].vehicle,
          buildType: res.data[0].buildType || 'Manual',
          safeDrop: res.data[0].safeDrop,
        };
        
        if (res.data[0].vehicle) this.getVehicleData(res.data[0].vehicle);
        if (res.data[0].holidayPattern) this.getHolidayList('', res.data[0]['holidayPattern']);

        if (this.routeType == 'occasional') this.formObject['toDate'] = res.data[0].toDate ? new Date(res.data[0].toDate) : '';
        if (this.routeType == 'openBooking') {
          this.formObject['branch'] = res.data[0]['branch'];
          this.formObject['shift'] = res.data[0]['shift'];
          this.formObject['blockDuration'] = res.data[0]['blockDuration'];
          if (res.data[0].bookingDays) {
            this.formObject['bookingDays'] = res.data[0]['bookingDays'];
            if (this.formObject['bookingDays'] == 'multiple') this.enableDaysCount = true;
          }
          if (res.data[0].dayCount) this.formObject['dayCount'] = res.data[0]['dayCount'];
          if (this.formObject['bookingDays'] == 'monthly') this.formObject['dayCount'] = 'null';
          if (res.data[0].branch) this.getBranchList('', res.data[0]['branch']);
        }
        setTimeout(() => {
          this.fieldChange({value:'' + res.data[0].isEnable}, 'dropdown','isEnable');
          this.timeValidation({ target: { value: this.getTimeString(res.data[0].startTimeStr)}}, 'startTime');
          this.getAvailableVehicleList();
          if (this.routeType == 'openBooking') {
            this.getBranchList();
            if (res.data[0].shift) this.getListShift('', res.data[0]['shift']);
          }
          this.getPickupData();    // pickup point data
          // this.setVehicleTable();
        }, 1000);

      }
    });
  }
  // Available vehicle
  getAvailableVehicleList(search?) {
    let fieldObj: any;
    if (this.createAutoRoute) fieldObj = { ...this.routeData };
    else fieldObj = { ...this.formObject };
    if (fieldObj.fromDate && fieldObj.startTime && fieldObj.endTime) {
      const obj = {
        routeStartTime: this.getDecimalTime(fieldObj.startTime),
        routeEndTime: this.getDecimalTime(fieldObj.endTime),
      };
      if (search && search != '') obj['vehRegNo'] = search;
      if (this.routeType == 'occasional') {
        if (fieldObj.toDate == undefined || fieldObj.toDate == '') return;
        else {
          obj['fromDate'] = new Date(fieldObj.fromDate).getTime();
          obj['toDate'] = new Date(fieldObj.toDate).getTime();
          this.api.transportManagerOccasionalRouteAvailableVeh(obj).then((res: any) => {
            if (res.status == 'success') {
              this.patchAvailableVehicle(res.data);
            }
          }).catch((err) => {
            console.log(err);
          });
        }
      }
      else {
        let apiMethodName = 'transportManagerRegularRouteAvailableVeh';
        if (this.routeType == 'openBooking') apiMethodName = 'transportManagerOBRouteAvailableVeh';
        obj['date'] = new Date(fieldObj.fromDate).getTime();
        this.api[apiMethodName](obj).then((res: any) => {
          if (res.status == 'success') {
            this.patchAvailableVehicle(res.data);
          }
        }).catch((err) => { console.log(err); });
      }
    }
  }
  // Pickup point list
  getPickupList() {
    this.pickupPoints = [];

    let apiMethod = 'listRoutePickupPoint';
    if (this.routeType == 'openBooking') apiMethod = 'transportManagerOpenBookingRouteListPP';

    this.api[apiMethod]({ routeID: this.routeID }).then((res: any) => {
      if (res.status == 'success') {
        this.pickupPoints = res.data;
      }
      if (this.vehicleListObject && this.routeData) {
        this.setVehicleTable();
      } else console.log('else part works');

    });
  }
  // Automatic route pickup point list
  getAutomaticPickupList() {
    let routeVehicle = this.routeData && this.routeData['vehicle'];
    this.pickupPoints = [];

    let apiMethod = 'listRoutePickupPoint';
    if (this.routeType == 'openBooking') apiMethod = 'transportManagerOpenBookingRouteListPP';

    this.api[apiMethod]({ "routeID": this.routeID, vehRegNo: routeVehicle }).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          this.automaticPickupInfo = res && res.data;
          this.pickupPoints = res && res.data;
          this.enableAddEmployee = false;
          this.createAutoRoute = false;
          this.empPanelShow = false;
          this.vehPanelShow = false;
          this.automaticVehTableData = [];
          this.setVehicleTable();
        }
        else {
          this.createAutoRoute = true;
          this.empPanelShow = true;
          this.enableAddEmployee = true;
        }
        // this.patchAutoVehicleTable();
      } else {
        this.createAutoRoute = true;
        this.empPanelShow = true;
        this.enableAddEmployee = true;
      }
    })
  }
  // Vehicle startLocation and EndLocation
  getVehStLocEndLoc(regNo) {
    return new Promise((resolve, rej) => {
      try {
        let obj = { routeID: this.routeID, vehRegNo: regNo }
        this.api.transportManagerRouteStEndLocList(obj).then((res: any) => {
          if (res.status == 'success') {
            resolve(res.data);
          }
        })
        //  res()
      } catch (error) {
        rej({})
      }
    })
  }

  /* API call supportive methods */
  // Pickup point list call
  getPickupData() {
    // routeVehicle = routeVehicle.map((v)=>{ return v; })
    if (this.routeData['buildType'] && this.routeData['buildType'] == 'Automatic') {
      this.getAutomaticPickupList();
    }
    else {
      this.getPickupList();     // get pickup info 
    }

  }
  // Time string
  getTimeString(timeString) {     // time '10:20'
    let splitTime = timeString.split(":");            // 10, 20
    splitTime[1] = splitTime[1] == undefined ? '0' : splitTime[1];
    let hour = this.comservice.pad(Number(splitTime[0]));
    let minute = this.comservice.pad(Number(splitTime[1]));
    let timeformat = `${hour}:${minute}`;
    return timeformat;
  }

  /* Form Fields Configuration */
  // Form Expand
  formExpandMore() {
    this.formExpand = true;
    setTimeout(() => { this.formColumnExpand = true }, 100);
  }
  formExpandLess() {
    this.formExpand = false;
    setTimeout(() => { this.formColumnExpand = false }, 100);
  }
  panelExpandMore(panel) {
    this[panel] = true;
    if (panel == 'vehPanelExpand') {
      this.getAvailableVehicleList();
    }
  }
  panelExpandLess(panel) { this[panel] = false; }

  empPanelSubmit() {
    this.vehPanelShow = true;
    this.panelExpandLess('empPanelExpand');
    this.panelExpandMore('vehPanelExpand');
  }

  // shift Field
  getShiftFieldData(branch, shift?) {
    this.showShiftField = false;
    this.shiftlists = [];
    if (shift == undefined || shift == '') this.selectedShift = [];
    if (this.shiftInformation && Array.isArray(this.shiftInformation) && this.shiftInformation.length > 0) {
      this.shiftInformation.map((item) => {
        let obj = { name: item.shiftName, value: item.shiftID };
        if (item.branch == branch) this.shiftlists.push(obj);
      })
    }
    if (branch) this.disableShiftField = false;
    if (shift && shift != '') this.dropdownSelectionResult(shift, 'selectedShift', 'shiftlists', 'showShiftField', 'shiftSearchTextBox');
    setTimeout(() => {
      this.showShiftField = true;
    }, 100);
  }

  setShiftFieldData(shift) {
    this.showShiftField = false;
    this.selectedShift = [];
    if (this.shiftlists && this.shiftlists.length > 0) {
      this.shiftlists.filter((item) => { if (item.value == shift) this.selectedShift.push(item); });
    }
    setTimeout(() => { this.showShiftField = true; }, 100);
  }

  // Branch Field

  setBranchFieldData(branch) {
    this.showBranchField = false;
    this.selectedBranch = [];
    if (this.branchlists && this.branchlists.length > 0) {
      this.branchlists.filter((item) => { if (item.value == branch) this.selectedBranch.push(item); });
    }
    setTimeout(() => { this.showBranchField = true; }, 100);
  }

  // Dropdown Search & select methods
  dropdownSearchChange(searchValue: string, typeOfObserver, APIMethod) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this[typeOfObserver]) {
      new Observable(observer => {
        this[typeOfObserver] = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this[APIMethod](term);
        });
    }

    this[typeOfObserver].next(searchValue);
  }

  dropdownSearchClear(srchTextBox, APIMethod) {
    this[srchTextBox].nativeElement.value = '';
    this[APIMethod]();
  }

  dropdownSelectionResult(value, selected, optionList, toggleField, srchTextBox) {
    if (!Array.isArray(value)) value = [value];
    let result = [];
    let removedResult = [];

    for (let i = 0; i < value.length; i++) {
      let val = value[i];
      this[selected].map((item) => {
        if (item.value == val) {
          let valIndex = result.findIndex((e) => e.value == item.value);
          if (valIndex == -1) result.push(item);
        }
      })
      this[optionList].map((veh) => {
        if (veh.value == val) {
          let valIndex = result.findIndex((e) => e.value == veh.value);
          if (valIndex == -1) result.push(veh);
        }
      })
    }

    this[selected].map((sel) => {
      if (!value.includes(sel.value)) {
        let pushObj: boolean = true;
        removedResult.map((e) => { if (e.value == sel.value) pushObj = false; });
        if (pushObj) removedResult.unshift(sel);
      }
    })

    this[toggleField] = false;
    this[optionList] = [...removedResult, ...this[optionList]]
    this[toggleField] = true;

    this[selected] = [...result];
    if (this[srchTextBox] && this[srchTextBox].nativeElement)
      this[srchTextBox].nativeElement.value = '';
    this.clearDuplicates(selected, optionList, toggleField);
  }

  clearDuplicates(selected, optionList, toggleField) {
    let result = [];
    this[toggleField] = false;
    this[optionList].map((obj) => {

      let pushObj: boolean = true;
      this[selected].map((item) => { if (item.value == obj.value) pushObj = false; });
      if (pushObj) result.push(obj);

    });
    this[optionList] = [...result];
    this[toggleField] = true;
  }

  // Vehicle Field
  setVehicleFieldData(vehicles) {
    this.showVehicleField = false;
    let vehConfig = true;
    this.vehiclelists.filter((veh) => { if (veh.checked) vehConfig = false; });
    if (vehConfig) {
      this.vehiclelists = this.vehiclelists.map((veh) => {
        const info = this.vehicleListObject[veh.value];
        let obj = {
          name: info.name,
          regNo: info.vehRegNo,
          value: info.vehRegNo,
        }

        if (info['capacity']) {
          obj['badge'] = info['capacity'],
            obj['badgeColor'] = 'light';
        }

        if (vehicles && vehicles.length > 0) {
          let check = vehicles.indexOf(veh.value);
          if (check != -1) obj['checked'] = true;
        }
        return obj;

      });
      this.showVehicleField = true;
    }
    else {
      if (this.vehiclelists.length > 0) {
        for (let v = 0; v < this.vehiclelists.length; v++) {
          this.vehiclelists[v]['checked'] = false;
          if (vehicles && vehicles.length > 0) {
            let check = vehicles.indexOf(this.vehiclelists[v]['value']);
            if (check != -1) this.vehiclelists[v]['checked'] = true;
          }
        }
      }
      setTimeout(() => { this.showVehicleField = true; this.disableVehicleField = false; }, 100);
    }
  }

  // Available vehicle
  patchAvailableVehicle(data) {
    this.showVehicleField = false;
    this.vehiclelists = [];
    this.vehiclelists = data.map(item => {

      if (this.allVehicles[item.vehRegNo] == undefined) this.allVehicles[item.vehRegNo] = {};
      this.allVehicles[item.vehRegNo] = item;

      let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '---';
      const name = item.vehRegNo.toUpperCase() + ' ' + model;
      this.vehicleListObject[item.vehRegNo] = { name, ...item };
      let obj = {
        "name": name, value: item.vehRegNo,
      }

      if (item['capacity']) {
        obj['badge'] = item['capacity'],
          obj['badgeColor'] = 'light';
      }

      return obj;
    });

    setTimeout(() => {
      this.showVehicleField = true;
      this.disableVehicleField = false;
      this.clearDuplicates('selectedVehicle', 'vehiclelists', 'showVehicleField');
    }, 200);
  }

  /* Vehicle Table */
  // set manual route vehicle table
  async setVehicleTable() {
    let vehicleStEndLoc = await this.getVehStLocEndLoc(this.routeData['vehicle']);
    this.vehicleTableData = [];
    if (this.pickupPoints && this.vehicleListObject && this.routeData) {
      if (this.routeData['vehicle'].length > 0) {
        this.enableRouteExlDownload = true;
        this.routeData['vehicle'].map(async (veh) => {
          let duration = '00:00:00';
          let distance = 0;

          if (vehicleStEndLoc[veh] && vehicleStEndLoc[veh]['distance']) {
            distance = Math.floor(Math.abs(Number(vehicleStEndLoc[veh]['distance'])));
          }
          if (vehicleStEndLoc[veh] && vehicleStEndLoc[veh]['duration']) {
            duration = this.decimalToTime(vehicleStEndLoc[veh]['duration']);
          }
          let obj = {
            routeID: this.routeID,
            tripStatus: '1',
            availableSeats: 0,
            ppCounts: 0,
            duration: duration,
            distance: distance,
            vehRegNo: veh,
            startLoc: vehicleStEndLoc[veh] && vehicleStEndLoc[veh]['startLoc'] ? this.getStEndLocName(vehicleStEndLoc[veh]['startLoc']) : '',
            endLoc: vehicleStEndLoc[veh] && vehicleStEndLoc[veh]['endLoc'] ? this.getStEndLocName(vehicleStEndLoc[veh]['endLoc']) : '',
            model: this.vehicleListObject[veh] ? this.vehicleListObject[veh]['model'] : '---',
            capacity: this.vehicleListObject[veh] ? this.vehicleListObject[veh]['capacity'] : '0',
            location: this.vehicleListObject[veh] && this.vehicleListObject[veh]['location'] ? this.vehicleListObject[veh]['location']['name'] : '---',
          };

          this.pickupPoints.filter((pp) => {
            if (pp.vehRegNo == veh) {
              if (pp.employees && pp.employees.length > 0) {
                obj['availableSeats'] += pp.employees.length;
                for (let e = 0; e < pp.employees.length; e++) {
                  if (pp.employees[e] && pp.employees[e]['gender']) {
                    if (pp.employees[e].gender == "Male") {
                      if (pp.employees[e].department && pp.employees[e].department == "escort") {
                        obj['escortIcon'] = true;
                        if (obj['escortCount'] == undefined) obj['escortCount'] = 0;
                        obj['escortCount']++;
                      }
                      else {
                        obj['maleIcon'] = true;
                        if (obj['maleCount'] == undefined) obj['maleCount'] = 0;
                        obj['maleCount']++;
                      }
                    }
                    if (pp.employees[e].gender == 'Female') {
                      if (pp.employees[e].department && pp.employees[e].department == "escort") {
                        obj['escortIcon'] = true;
                        if (obj['escortCount'] == undefined) obj['escortCount'] = 0;
                        obj['escortCount']++;
                      }
                      else {
                        obj['femaleIcon'] = true;
                        if (obj['femaleCount'] == undefined) obj['femaleCount'] = 0;
                        obj['femaleCount']++;
                      }
                    }
                  }
                }
              }
              if (pp.guest && pp.guest.length > 0) {
                obj['availableSeats'] += pp.guest.length;
                for (let e = 0; e < pp.guest.length; e++) {
                  if (pp.guest[e].gender) {
                    if (pp.guest[e].gender == "Male") {
                      if (pp.guest[e].userType && pp.guest[e].userType == "Escort") {
                        obj['escortIcon'] = true;
                        if (obj['escortCount'] == undefined) obj['escortCount'] = 0;
                        obj['escortCount']++;
                      } else {
                        obj['maleIcon'] = true;
                        if (obj['maleCount'] == undefined) obj['maleCount'] = 0;
                        obj['maleCount']++;
                      }
                    }
                    if (pp.guest[e].gender == 'Female') {
                      if (pp.guest[e].userType && pp.guest[e].userType == "Escort") {
                        obj['escortIcon'] = true;
                        if (obj['escortCount'] == undefined) obj['escortCount'] = 0;
                        obj['escortCount']++;
                      } else {
                        obj['femaleIcon'] = true;
                        if (obj['femaleCount'] == undefined) obj['femaleCount'] = 0;
                        obj['femaleCount']++;
                      }
                    }
                  }
                }
              }
              obj['enableExl'] = true;
              obj['ppCounts'] += 1;
              obj['tripStatus'] = String(pp.tripStatus);
            }
          });
          if (this.vehicleTableData.findIndex((veh) => veh.vehRegNo == obj.vehRegNo) == -1) this.vehicleTableData.push(obj);
        });
      }
    }
  }
  // set auto route vehicle table
  patchAutoVehicleTable() {
    //   let vehicleStEndLoc = await this.getVehStLocEndLoc(this.routeData['vehicle']);
    this.automaticVehTableData = [];
    if (this.vehicleListObject && this.formObject.vehicle && this.formObject.vehicle.length > 0) {
      for (let v = 0; v < this.formObject.vehicle.length; v++) {
        let veh = this.formObject.vehicle[v];
        let obj = {
          routeID: this.routeID,
          vehRegNo: veh,
          startLoc: this.vehStartEndLoc[veh] && this.vehStartEndLoc[veh]['startLoc'] ? this.vehStartEndLoc[veh]['startLoc'] : '',
          endLoc: this.vehStartEndLoc[veh] && this.vehStartEndLoc[veh]['endLoc'] ? this.vehStartEndLoc[veh]['endLoc'] : '',
          model: this.vehicleListObject[veh] ? this.vehicleListObject[veh]['model'] : '---',
          capacity: this.vehicleListObject[veh] ? this.vehicleListObject[veh]['capacity'] : '0',
          location: this.vehicleListObject[veh] && this.vehicleListObject[veh]['location'] ? this.vehicleListObject[veh]['location']['name'] : '---',
        };
        if (this.automaticVehTableData.findIndex((vehicle) => vehicle.vehRegNo == obj.vehRegNo) == -1) this.automaticVehTableData.push(obj);
      }
    }
  }

  /* Vehicle Table Methods */
  // Table Icon column width checking
  checkAllIconWidth(trip) {
    let returnValue: boolean = false;
    if (trip.escortIcon && trip.maleIcon && trip.femaleIcon) returnValue = true;
    return returnValue;
  }
  checkSingleIconWidth(trip) {
    let returnValue: boolean = false;
    if (trip.escortIcon && (trip.maleIcon == undefined && trip.femaleIcon == undefined)) returnValue = true;
    else if (trip.maleIcon && (trip.escortIcon == undefined && trip.femaleIcon == undefined)) returnValue = true;
    else if (trip.femaleIcon && (trip.maleIcon == undefined && trip.escortIcon == undefined)) returnValue = true;
    return returnValue;
  }
  checkCombinedIconWidth(trip) {
    let returnValue: boolean = false;
    if (trip.escortIcon && trip.maleIcon && !trip.femaleIcon) returnValue = true;
    else if (trip.escortIcon && !trip.maleIcon && trip.femaleIcon) returnValue = true;
    else if (!trip.escortIcon && trip.maleIcon && trip.femaleIcon) returnValue = true;
    return returnValue;
  }

  // decimal to Duration time
  decimalToTime(etd) {
    let hour = 0;
    let min = 0;
    // let min = Math.floor(Math.abs(etd));
    let arraySplit = String(etd).split('.');
    if (arraySplit[1]) {
      hour = Number(arraySplit[0]);
      min = Number(arraySplit[1]);
    }
    else hour = Number(arraySplit[0]);
    if (min > 60) { hour += Math.floor(min / 60); min = Math.floor(min % 60); }
    return (hour < 10 && String(hour).length == 1 ? "0" : "") + hour + ":" + (min < 10 && String(hour).length == 1 ? "0" : "") + min + ":00";
  }
  // get vehicle start and end location name
  getStEndLocName(loc) {
    return loc['title'] ? loc['title'] : (loc['name'] ? loc['name'] : '');
  }
  // update vehicle status in table
  updateStatus(vehicle, index) {
    let status = vehicle.tripStatus;
    if (status == '0') status = '1';
    else status = '0';

    let obj = {
      routeID: this.routeID,
      vehRegNo: vehicle.vehRegNo,
      //pickuppointID: vehicle.pickuppointID,
      tripStatus: Number(status),
    };

    this.api.transportManagerRouteStatusUpdate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        setTimeout(() => {
          this.getPickupList();
        }, 2500);
      } else {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });

    // this.vehicleTableData[index].status = status;

  }
  // get confirmation for Delete vehicle
  deleteTripVeh(veh) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this vehicle!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          routeID: this.routeID,
          vehRegNo: veh.vehRegNo,
          forceDelete: false,
        };
        this.deleteTrip(obj);
      }
    });
  }
  // delete vehicle
  deleteTrip(obj) {
    this.api.transportManagerRouteTripDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.removeDelVehInList(obj.vehRegNo);
      }
      if (res.status == 'failure' || res.status == 'Failure') {
        this.forceDelete('warning', res.message, obj);
        // this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  forceDelete(Icon: any, Text: any, reqObj) {
    Swal.fire({
      title: 'Are you sure?',
      text: Text,
      icon: Icon.toLowerCase(),
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Force delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = { ...reqObj, forceDelete: true };
        this.deleteTrip(obj);
      }
    });
  }
  // remove delete vehicle in vehicle table 
  removeDelVehInList(vehRegNo) {
    this.showVehicleField = false;

    this.formObject.vehicle = this.formObject.vehicle.filter((veh) => veh != vehRegNo);
    if (this.routeData['vehicle']) this.routeData['vehicle'] = this.routeData['vehicle'].filter((veh) => veh != vehRegNo);
    let removedResult = [];
    let result = [];
    this.selectedVehicle.map((sel) => {
      if (sel.value == vehRegNo) {
        removedResult.unshift(sel);
      }
      else result.push(sel);
    });
    this.vehiclelists = [...removedResult, ...this.vehiclelists];
    this.selectedVehicle = [...result];

    this.clearDuplicates('selectedVehicle', 'vehiclelists', 'showVehicleField');

    setTimeout(() => {
      this.showVehicleField = true;
      if (this.formObject.buildType == 'Automatic') {
        if (this.createAutoRoute) {
          this.selectedVehicleSeats = this.getSeatsCounts(this.formObject['vehicle']);
          this.patchAutoVehicleTable();
        }
        else if (!this.createAutoRoute && this.routeData['vehicle'] && this.routeData['vehicle'].length <= 0) {
          this.vehicleTableData = [];
          this.automaticSelectedEmps = {};
          this.getAutomaticPickupList();
        }
        else if (!this.createAutoRoute && this.routeData['vehicle'] && this.routeData['vehicle'].length > 0) {
          this.setVehicleTable();
        }
      }
      else this.setVehicleTable();
    }, 500);
  }

  /* Manage Pickup point */
  managePickupPoint(veh) {
    this.selectedVeh = this.allVehicles[veh];
    this.activePanel = 'PickupPoint';
  }
  /* Get Route Type(regular or occasional) */
  getRouteType(e: any) {
    //this.routeID = '';
    // console.log(e);
    //this.formObject.routeType = e;
  }

  /* Common supportive methods */
  // string Time to decimal Time
  getDecimalTime(time) {
    var hoursMinutes = String(time).split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 100;
  }

  /* Getting Form Field Results */
  // Build type field
  patchBuildType(e) {
    if (e.value == 'Automatic') {
      this.createAutoRoute = true;
      if (this.routeID == undefined || this.routeID == '') {
        this.formExpandMore();
        // delete this.formObject.vehicle;
        // if(this.formObject.vehicle) this.formObject.vehicle = [];
      }
    }
    else {
      this.createAutoRoute = false;
      if (this.formObject.vehicle == undefined) this.formObject.vehicle = [];
    }
    this.fieldChange(e, 'radio', 'buildType');
  }
  // branch Field
  getBranchResult(value) {
    this.formObject.branch = value;
    this.disableShiftField = true;
    this.formObject.shift = '';
    this.dropdownSelectionResult(value, 'selectedBranch', 'branchlists', 'showBranchField', 'branchSearchTextBox');
    // this.getShiftFieldData(value);
    this.getListShift();
    if (value) this.fieldChange(this.formObject.branch, 'dropdown', 'branch');
  }
  // shift Field
  getShiftResult(value) {
    this.formObject.shift = value;
    this.dropdownSelectionResult(value, 'selectedShift', 'shiftlists', 'showShiftField', 'shiftSearchTextBox');
    if (value) this.fieldChange(this.formObject.shift, 'dropdown', 'shift');
  }
  // vehicle Field
  getVehicleResult(value) {
    this.formObject.vehicle = value;
    this.dropdownSelectionResult(value, 'selectedVehicle', 'vehiclelists', 'showVehicleField', 'vehicleSearchTextBox');
    this.fieldChange(this.formObject.vehicle, 'dropdown', 'vehicle');
    if (this.formObject.buildType == 'Automatic' && this.createAutoRoute) {
      this.patchAutoVehicleTable();
      this.allVehHavLoc = this.checkAllVehHaveLoc(this.formObject.vehicle);
      this.selectedVehicleSeats = this.getSeatsCounts(this.formObject['vehicle']);
    }
  }

  // Holiday field
  getHolidayResult(value) {
    // this.formObject.holidayPattern = selected.map((holiday) => { return holiday.value; });
    this.formObject.holidayPattern = value;
    this.dropdownSelectionResult(value, 'selectedHoliday', 'holidaylists', 'showHolidayField', 'holidaySearchTextBox');
    this.fieldChange(this.formObject.holidayPattern, 'dropdown', 'holidayPattern');
  }
  // TransitMode field
  transitModeChange(event) {
    this.fieldChange(event, 'dropdown', 'trasitMode')
  }
  // Booking Day Field
  bookingDaysChange(event) {
    if (event.value == 'multiple') {
      this.enableDaysCount = true;
      this.formObject['dayCount'] = 5;
    } else {
      this.enableDaysCount = false;
      this.formObject['dayCount'] = 1;
    }

    if (event.value == 'monthly') {
      this.enableDaysCount = false;
      this.formObject['dayCount'] = 'null';
    }
    this.fieldChange(event, 'dropdown', 'bookingDays');
    this.fieldChange({ target: { value: this.formObject['dayCount'] } }, 'text', 'dayCount');
  }
  // Attendance Field
  attendanceChange(event) {
    if (event && event.value && event.value.includes('Not Required')) {
      event.value = ['Not Required'];
      this.formObject['attendence'] = event.value;
      this.attendanceType.patchValue(event.value);
    }
    this.fieldChange(event, 'dropdown', 'attendence')
  }
  // keyword field
  keywordModified(keywords) {
    this.formObject.keywords = keywords.map((item) => {
      return item.name;
    })
    this.fieldChange(this.formObject.keywords, 'chipInput', 'keywords');
  }
  // Date
  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.formObject[type] = x.getTime();
      this.fieldChange(x, 'date', type);
    });
    this.getAvailableVehicleList();
  }
  dateResult(date, type, field) {
    if (date) this.formObject[field] = date;
    this.fieldChange(date, type, field);
    this.getAvailableVehicleList();
  }
  // Time
  timeValidation(event, type) {
    this.fieldChange(event, 'time', type);
    this.getAvailableVehicleList();
  }



  /* ----------- Automatic Route --------------- */

  /* Automatic route employee action methods */
  // get seat counts
  getSeatsCounts(vehicleList) {
    let counts = 0;
    if (Object.keys(this.vehicleListObject).length > 0 && vehicleList && vehicleList.length > 0) {
      vehicleList.filter((veh) => {
        if (this.vehicleListObject[veh] && this.vehicleListObject[veh]['capacity']) counts += Number(this.vehicleListObject[veh]['capacity']);
      })
    }
    return counts;
  }
  // Get selected employee
  getSelectedEmployees(obj: any) {
    this.automaticSelectedEmps = obj;
    for (let key in obj) {
      this.getSelectedEmpList[key] = true;
    }
    this.closePopup = true;
  }
  // Delete all employee
  deleteAllEmp() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete all employees!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.automaticSelectedEmps = {};
        this.getSelectedEmpList = {};
        Swal.fire(
          'Deleted!',
          'Employees has been deleted.',
          'success'
        );
      }
    });
  }
  // Delete selected employee
  deleteSelectedPickEmp(key: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this employee!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        delete this.getSelectedEmpList[key];
        delete this.automaticSelectedEmps[key];
        Swal.fire(
          'Deleted!',
          'Employee has been deleted.',
          'success'
        );
      }
    });
  }
  // get selected start and end location
  //load modal to get location
  getStEndLocation(vehRegNo, field) {
    this.stEndLocVehRegNo = vehRegNo;
    this.editStEndLocation = false;
    this.selectedStEndLoc = {};
    this.selectedLocType = field;
    if (field == 'start Location') this.stEndLocModalTitle = "Start Location";
    else if (field == 'end Location') this.stEndLocModalTitle = "End Location";
    this.closeStEndLocPopup = false;
  }
  // modal results
  selectedStEndLocation(event) {
    if (this.vehStartEndLoc[this.stEndLocVehRegNo] == undefined) this.vehStartEndLoc[this.stEndLocVehRegNo] = {};
    if (this.selectedLocType == 'start Location') {
      this.vehStartEndLoc[this.stEndLocVehRegNo]['startLoc'] = { ...event };
    }
    else if (this.selectedLocType == 'end Location') {
      this.vehStartEndLoc[this.stEndLocVehRegNo]['endLoc'] = { ...event };
    }
    this.closeStEndLocPopup = true;
    this.allVehHavLoc = this.checkAllVehHaveLoc(this.formObject.vehicle);
    this.patchAutoVehicleTable();
  }
  // Edit start and end location 
  setStEndLocation(vehRegNo, field) {
    this.selectedLocType = field;
    this.selectedStEndLoc = {};
    if (field == 'start Location') {
      this.stEndLocModalTitle = "Start Location";
      this.selectedStEndLoc = { ...this.vehStartEndLoc[vehRegNo]['startLoc'] };
    }
    else if (field == 'end Location') {
      this.stEndLocModalTitle = "End Location";
      this.selectedStEndLoc = { ...this.vehStartEndLoc[vehRegNo]['endLoc'] };
    }
    this.editStEndLocation = true;
    this.closeStEndLocPopup = false;
  }
  checkAllVehHaveLoc(vehicle) {
    let result = true;
    if (Array.isArray(vehicle) && vehicle.length > 0) {
      vehicle.filter((veh) => {
        if (this.vehStartEndLoc[veh] == undefined) result = false;
        else if (this.vehStartEndLoc[veh].startLoc == undefined || Object.keys(this.vehStartEndLoc[veh].startLoc).length <= 0) result = false;
        else if (this.vehStartEndLoc[veh].endLoc == undefined || Object.keys(this.vehStartEndLoc[veh].endLoc).length <= 0) result = false;
      })
    } else {
      result = false;
    }
    return result;
  }

  /* Generate Route before validation popup */
  // Check Generate Route
  getFemaleEmpCount(Emp) {
    this.getSafeDrop = false;
    let count = 0;
    let keys = [];
    if (typeof (Emp) === 'object') keys = Object.values(Emp);
    else if (Array.isArray(Emp)) keys = Emp;
    keys.filter((emp) => {
      if (emp['gender'] == "Female") count++;
    })
    if (count > 0) this.getSafeDrop = true;
    return count;
  }
  checkGenerateRoute() {
    if (this.pickupPoints.length <= 0) {
      this.selectedEmpCounts = Object.keys(this.automaticSelectedEmps).length;
      this.selectedFemaleEmpCounts = this.getFemaleEmpCount(this.automaticSelectedEmps);
      this.selectedVehicleSeats = this.getSeatsCounts(this.formObject['vehicle']);
      this.selectedVehicleCounts = this.formObject['vehicle'].length;
      if (this.selectedEmpCounts > this.selectedVehicleSeats)
        this.addMoreVehicleConfirmation();
      else if (this.selectedEmpCounts < this.selectedVehicleSeats)
        this.addMoreEmployeeConfirmation()
      else if (this.selectedEmpCounts == this.selectedVehicleSeats) {
        // this.generateroute();
        this.routeCreateNextmvApi();
      }
    }
  }
  checkSeatCount() {
    let returnClass = 'text-primary';
    if (Object.keys(this.automaticSelectedEmps).length > this.getSeatsCounts(this.formObject.vehicle)) returnClass = 'text-danger';
    return returnClass
  }
  checkEmpCount() {
    let returnClass = 'text-primary';
    if (Object.keys(this.automaticSelectedEmps).length < this.getSeatsCounts(this.formObject.vehicle)) returnClass = 'text-warning';
    if (Object.keys(this.automaticSelectedEmps).length == 0) returnClass = 'text-danger';
    return returnClass
  }
  // Add More vehicle confirmation
  addMoreVehicleConfirmation() {

    let fireContent = {
      title: 'Add More Vehicle!',
      html: '<div class="row">' +
        '<div class="col-12"><span class="Text-center">You have selected</span></div>' +
        `<div class="col-12"><span> ${this.selectedVehicleCounts} Vehicles ( ${this.selectedVehicleSeats} ${this.selectedVehicleSeats > 1 ? 'seats' : 'seat'} )</span></div>` +
        `<div class="col-12"><span> ${this.selectedEmpCounts} Employees </span></div>`,
      icon: 'warning',
    };
    Swal.fire(fireContent);
  }

  addMoreVehicleResult(event) {
    if (Array.isArray(event) && event.length > 0) {
      this.setVehicleFieldData(event);
      setTimeout(() => {
        // this.generateroute();
        this.routeCreateNextmvApi();
      }, 500);
    }
  }
  // Add more employee confirmation
  addMoreEmployeeConfirmation() {
    let fireContent = {
      title: 'Add More Employee?',
      html: '<div class="row">' +
        '<div class="col-12"><span class="Text-center">You have selected</span></div>' +
        `<div class="col-12"><span> ${this.selectedVehicleCounts} Vehicles ( ${this.selectedVehicleSeats} ${this.selectedVehicleSeats > 1 ? 'seats' : 'seat'} )</span>` +
        `<span> ${this.selectedEmpCounts} Employees </span></div>`,
      icon: 'question',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#5cb85c',
      confirmButtonText: 'Add Employee',
      cancelButtonColor: '#3085d6',
      cancelButtonText: 'Generate Route',
    };
    Swal.fire(fireContent).then((result) => {
      if (result.isConfirmed) {
        this.closePopup = false;
        this.panelExpandMore('empPanelExpand');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // this.generateroute();
        this.routeCreateNextmvApi();
      }
    });
  }
  // Female employee safe drop confirmation
  safeDropConfirmation() {
    Swal.fire({
      title: 'Safe Drop!',
      html: '<div class="row">' +
        '<div class="col-12"><span class="Text-center">You have selected</span></div>' +
        `<div class="col-12"><span> ${this.selectedVehicleCounts} Vehicles ( ${this.selectedVehicleSeats} ${this.selectedVehicleSeats > 1 ? 'seats' : 'seat'} )</span></div>` +
        `<div class="col-12">${this.selectedEmpCounts} Employees ( ${this.selectedFemaleEmpCounts} Female ${this.selectedFemaleEmpCounts > 1 ? 'Employees' : 'Employee'} ) </span></div>` +
        `<div class="col-12 mt-3">Do you prefer safe drop ?</div>` +
        `<div class="col-12"><input type="checkbox" id="safeDropCheckbox" name="safeDrop" [(ngModel)]="safeDrop" [checked]="safeDrop"
      (change)="safeDropChange()"/><label class="pl-2" for="safeDropCheckbox">yes</label></div>`,
      icon: 'info',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Generate Route',
      cancelButtonColor: '#d33',
      //cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        // this.generateroute();
        this.routeCreateNextmvApi();
      }
    });
  }
  safeDropChange() {
    this.safeDrop = !this.safeDrop;
  }
  // Un-assigned Employee confirmation
  addUnassignedConfirmation() {
    let fireContent = {
      title: 'Unassigned Employees!',
      html: '<div class="row">' +
        '<div class="col-12"><span class="Text-center">You have Unassigned Employees</span></div>' +
        `<div class="col-12"><span> ${this.selectedEmpCounts} Employees </span></div>`,
      icon: 'info',
      showCancelButton: true,
    };
    Swal.fire(fireContent).then((result) => {
      if (result.isConfirmed) {
        //this.generateroute();
        // add single vehicle popup enable
      }
      else if ((result.dismiss === (Swal.DismissReason.cancel || Swal.DismissReason.close)) || result.isDismissed) {
        this.unassingedEmps = [];
      }
    });
  }


  // Generate auto route
  async generateroute() {
    this.loader.show();
    let routeCreateObj = {
      transitMode: this.formObject.trasitMode,
      safeDrop: this.formObject.safeDrop,
    }
    let selectedVehicleForthisRoute = this.formObject['vehicle'].map((item) => {

      let obj = {
        vehRegNo: this.allVehicles[item].vehRegNo,
        CarName: this.allVehicles[item].vehRegNo,
        SeatCapacity: this.allVehicles[item].capacity,
        model: this.allVehicles[item].model,
        location: {
          lat: this.allVehicles[item]['location']['lat'],
          lng: this.allVehicles[item]['location']['lng'],
          name: this.allVehicles[item]['location']['name'],
        },
        startLoc: { ...this.vehStartEndLoc[item].startLoc },
        endLoc: { ...this.vehStartEndLoc[item].endLoc },
      };
      return obj;
    });
    routeCreateObj['cabInfo'] = selectedVehicleForthisRoute;
    routeCreateObj['employeeInfo'] = Object.values(this.automaticSelectedEmps);
    // if(this.formObject.safeDrop) routeCreateObj.safeDrop = true; 

    let returnObj = await this.routeservice.routeCreate([routeCreateObj]);

    setTimeout(() => {
      this.automaticPickupInfo = returnObj['finalRoute'].map((element) => {
        let obj = { ...element };
        if (element.dropInfo) {
          obj['pickupInfo'] = element.dropInfo.map((obj) => { return { ...obj }; });
          delete obj['dropInfo'];
        }
        else obj['pickupInfo'] = element.pickupInfo.map((obj) => { return { ...obj }; });
        return obj;
      });
      setTimeout(() => {
        this.setAutoVehiclePickup();
        // unassigned Vehicles
        this.unassignedVehicles = [];
        selectedVehicleForthisRoute.filter((veh) => { this.unassignedVehicles.push(veh.vehRegNo); });
        this.unassignedVehicles.filter((unAssignVeh, index) => {
          this.automaticPickupInfo.filter((veh) => {
            if (veh['cabInfo'].vehRegNo == unAssignVeh) {
              this.unassignedVehicles.splice(index, 1);
            }
          })
        });
        setTimeout(() => { this.removeVehConfimation(this.unassignedVehicles); }, 500);
        this.unassingedEmps = returnObj['unAssignedEmp'];
      }, 500);
    }, 500);

    // if (this.unassingedEmps.length > 0) {
    //   this.selectedEmpCounts = this.unassingedEmps.length;
    //   this.selectedFemaleEmpCounts = this.getFemaleEmpCount(this.unassingedEmps);
    //   setTimeout(() => { this.addUnassignedConfirmation(); }, 500);
    // }
  }
  alertRouteGenerate() {
    let fireContent = {
      title: 'Route Generation Failure!',
      icon: 'warning',
    };
    fireContent['html'] = `<div class="row px-5">
                              <h5 class="col-12">Possibilities reason for failure.</h5>
                              <h6 class="col-12 px-4">
                              <ol>
                              <li class="text-left">All Employee Need location.</li>
                                <li class="text-left">Location might be too far.</li>
                              </ol></h6>
                            </div>`;
    Swal.fire(fireContent).then((result) => { console.log(result) });
  }
  async routeCreateNextmvApi() {
    let inputObj = await this.automaticRouteInput();
    this.generateBtnClicked = true;
    const returnObj: any = await this.routeservice.routeCreateNextmvApi([inputObj]).catch((e) => {
      console.log(e)
    });
    if (returnObj && returnObj.data) {
      let outputObj = { ...returnObj.data.state };
      let unassignedVeh = [];
      if (returnObj.data.state.vehicles.length > 0) {
        let vehicles = [];
        for (let v = 0; v < returnObj.data.state.vehicles.length; v++) {
          let vehData = returnObj.data.state.vehicles[v];
          if (vehData.route.length >= 3) {
            vehicles.push(vehData);
          } else {
            unassignedVeh.push(vehData);
            this.formObject.vehicle = this.formObject.vehicle.filter((veh) => veh != vehData.id);
            if (this.routeData['vehicle']) this.routeData['vehicle'] = this.routeData['vehicle'].filter((veh) => veh != vehData.id);
          }
        }
        outputObj.vehicles = vehicles;
      }
      if ((outputObj.unassigned && outputObj.unassigned.length > 0) || unassignedVeh.length > 0) {
        // console.log('unassigned popup should work');
        let fireContent = {
          title: 'Unassigned Vehicle!',
          icon: 'warning',
        };
        this.loader.hide();
        if (outputObj.unassigned.length > 0 && unassignedVeh.length <= 0) {
          // console.log('employee popup should work',outputObj.unassigned);
          let employeesNames = [];
          for (let u = 0; u < outputObj.unassigned.length; u++) {
            let [employeeId, gender] = outputObj.unassigned[u].id.split('$');
            if (this.automaticSelectedEmps[employeeId]) employeesNames.push(this.automaticSelectedEmps[employeeId].name);
          }
          if (employeesNames.length > 0) {

            let htmlContent = '';
            for (let r = 0; r < employeesNames.length; r++) {
              htmlContent += `<tr><td class="border-top-0" style="font-size:16px;">${r + 1 + '.'}</td><td class="border-top-0 text-left" style="font-size:16px;">${employeesNames[r].charAt(0).toUpperCase() + employeesNames[r].slice(1).toLowerCase()}</td></tr>`;
            }
            if (employeesNames.length > 1) fireContent['title'] = 'Unassigned Employees!';
            else fireContent['title'] = 'Unassigned Employee!';
            fireContent['html'] = `<div class="row px-5">
                                        <h5 class="col-12 fw600">Excess Employee will be removed.</h5>
                                        <div class="col-12 px-5" style="max-height:70px;overflow-y:auto;">
                                          <table class="table table-responsive table-sm"><tbody>`+ htmlContent + `</tbody></table>
                                        </div>
                                        <h5 class="col-12">Possibilities reason for unassigned.</h5>
                                        <h6 class="col-12 px-4">
                                        <ol>
                                          <li class="text-left">Location might be too far.</li>
                                          <li class="text-left">Less trip time duration.</li>
                                        </ol></h6>
                                      </div>`;
            Swal.fire(fireContent).then((result) => {
              if (result.isConfirmed) {
                this.automaticRouteDetailsUpdate(outputObj);
              }
              this.generateBtnClicked = false;
            });

          }

        }
        else if (outputObj.unassigned.length <= 0 && unassignedVeh.length > 0) {
          // console.log('vehicle popup should work');
          let vehicles = []
          for (let u = 0; u < unassignedVeh.length; u++) {
            if (unassignedVeh[u].id) vehicles.push(unassignedVeh[u].id);
          }
          if (vehicles.length > 0) {

            let htmlContent = '';
            for (let r = 0; r < vehicles.length; r++) {
              htmlContent += `<tr><td class="border-top-0" style="font-size:16px;">${r + 1 + '.'}</td><td class="border-top-0 text-left" style="font-size:16px;">${vehicles[r].toUpperCase()}</td></tr>`;
            }
            if (vehicles.length > 1) fireContent['title'] = 'Unassigned Vehicles!';
            else fireContent['title'] = 'Unassigned Vehicle!';
            fireContent['html'] = `<div class="row px-5">
                                        <h5 class="col-12 fw600">Excess vehicle will be removed.</h5>
                                        <div class="col-12 px-5" style="max-height:70px;overflow-y:auto;">
                                          <table class="table table-responsive table-sm"><tbody>`+ htmlContent + `</tbody></table>
                                        </div>
                                        <h5 class="col-12">Possibilities reason for unassigned.</h5>
                                        <h6 class="col-12 px-4">
                                        <ol>
                                          <li class="text-left">Location might be too far.</li>
                                          <li class="text-left">Less trip time duration.</li>
                                          <li class="text-left">No seats filled.</li>
                                        </ol></h6>
                                      </div>`;
            Swal.fire(fireContent).then((result) => {
              if (result.isConfirmed) {
                this.automaticRouteDetailsUpdate(outputObj);
              }
              this.generateBtnClicked = false;
            });
          }
        }
        else if (outputObj.unassigned.length > 0 && unassignedVeh.length > 0) {
          // console.log('vehicles & employee popup should work');
          let vehicles = []
          for (let u = 0; u < unassignedVeh.length; u++) {
            if (unassignedVeh[u].id) vehicles.push(unassignedVeh[u].id);
          }
          let employeesNames = []
          for (let u = 0; u < outputObj.unassigned.length; u++) {
            let [employeeId, gender] = outputObj.unassigned[u].id.split('$');
            if (this.automaticSelectedEmps[employeeId]) employeesNames.push(this.automaticSelectedEmps[employeeId].name);
          }
          if (vehicles.length > 0 || employeesNames.length > 0) {

            let vehContent = '';
            let empContent = '';
            for (let r = 0; r < vehicles.length; r++) {
              vehContent += `<tr><td class="border-top-0" style="font-size:16px;">${r + 1 + '.'}</td><td class="border-top-0 text-left" style="font-size:16px;">${vehicles[r].toUpperCase()}</td></tr>`;
            }
            for (let r = 0; r < employeesNames.length; r++) {
              empContent += `<tr><td class="border-top-0" style="font-size:16px;">${r + 1 + '.'}</td><td class="border-top-0 text-left" style="font-size:16px;">${employeesNames[r].charAt(0).toUpperCase() + employeesNames[r].slice(1).toLowerCase()}</td></tr>`;
            }

            if (vehicles.length > 1 && employeesNames.length == 1) fireContent['title'] = 'Unassigned Vehicles and Employee!';
            else if (vehicles.length == 1 && employeesNames.length > 1) fireContent['title'] = 'Unassigned Vehicle and Employees!'
            else if (vehicles.length > 1 && employeesNames.length > 1) fireContent['title'] = 'Unassigned Vehicles and Employees!';
            else fireContent['title'] = 'Unassigned Vehicle and Employee!';

            fireContent['html'] = `<div class="row px-5">
                                        <h5 class="col-12 fw600">Excess data will be removed.</h5>
                                        <div class="col-6" style="max-height:70px;overflow-y:auto;">
                                          <table class="table table-responsive table-sm"><tbody>`+ vehContent + `</tbody></table>
                                        </div>
                                        <div class="col-6" style="max-height:70px;overflow-y:auto;">
                                          <table class="table table-responsive table-sm"><tbody>`+ empContent + `</tbody></table>
                                        </div>
                                        <h5 class="col-12">Possibilities reason for unassigned.</h5>
                                        <h6 class="col-12 px-4">
                                        <ol>
                                          <li class="text-left">Location might be too far.</li>
                                          <li class="text-left">Less trip time duration.</li>
                                          <li class="text-left">No seats filled.</li>
                                        </ol></h6>
                                      </div>`;

            Swal.fire(fireContent).then((result) => {
              if (result.isConfirmed) {
                this.automaticRouteDetailsUpdate(outputObj);
              }
              this.generateBtnClicked = false;
            });
          }
        }

      } else if (outputObj.vehicles && outputObj.vehicles.length > 0) {
        this.automaticRouteDetailsUpdate(outputObj);
        this.generateBtnClicked = false;
      }
    } else {
      this.alertRouteGenerate();
      this.closeProgressBar = true;
    }

  }
  automaticRouteDetailsUpdate(outputObj) {
    this.loader.show();
    /* Vehicle updating */
    let vehicle = [];
    for (let v = 0; v < outputObj.vehicles.length; v++) {
      if (outputObj.vehicles[v]['id']) {
        vehicle.push(outputObj.vehicles[v]['id']);
      }
    }
    if (vehicle.length > 0) {
      let vehicleObj = {
        routeID: this.routeID,
        vehicle: vehicle,
      }
      this.api.transportMangerRouteUpdate(vehicleObj).then((res: any) => {
        if (res.status == 'success') {
          this.routeData['vehicle'] = vehicle;
          let successStEndLoc = true;
          for (let d = 0; d < outputObj.vehicles.length; d++) {
            let vehRegNo = outputObj.vehicles[d]['id'];
            let duration = Number(outputObj.vehicles[d]['travel_time']);
            let distance = Number(outputObj.vehicles[d]['travel_distance']);
            let stEndLocObj = {
              routeID: this.routeID,
              vehRegNo: vehRegNo,
              startLoc: { ...this.vehStartEndLoc[vehRegNo]['startLoc'] },
              endLoc: { ...this.vehStartEndLoc[vehRegNo]['endLoc'] },
              duration: duration,
              distance: distance,
            }
            this.api.transportManagerRouteStEndLocCreate(stEndLocObj).then((res: any) => {
              if (res.status == 'success') {
                // this.swal.swalFunction(res.status.toLowerCase(), res.status, res.message, 2000);
              } else {
                successStEndLoc = false;
                this.swal.swalFunction('error', res.status, res.message, 2000);
              }
            })

            if (d == outputObj.vehicles.length - 1 && successStEndLoc) {
              /* pickuppoints */
              let manyPickupPoints = [];
              for (let v = 0; v < outputObj.vehicles.length; v++) {
                let pickup = outputObj.vehicles[v];
                let vehRegNo = outputObj.vehicles[v].id;
                let pickupPoints = [];
                if (pickup.route) {
                  for (let p = 1; p < pickup.route.length - 1; p++) {
                    let pickupInfo = {
                      employees: []
                    };
                    let [employeeId, gender] = pickup.route[p].id.split('$');
                    if (this.automaticSelectedEmps[employeeId]) pickupInfo.employees.push(this.automaticSelectedEmps[employeeId]);
                    pickupInfo['locationName'] = pickup.route[p]['locationName'];
                    pickupInfo['title'] = pickup.route[p]['locationName'];
                    pickupInfo['lat'] = pickup.route[p].lat;
                    pickupInfo['lng'] = pickup.route[p].lon;
                    pickupInfo['distance'] = Number(pickup.route[p].distance);
                    if (p == 1) {
                      pickupInfo['eta'] = this.getEtaWithfromTime(this.routeData['startTimeStr'], pickup.route[p]['eta']);
                    }
                    else {
                      pickupInfo['eta'] = this.getEtaWithfromTime(pickupPoints[p - 2]['eta'], pickup.route[p]['eta']);
                    }
                    pickupInfo['radius'] = 1;
                    pickupInfo['tripStatus'] = 1;
                    pickupInfo['pickuppointStatus'] = 1;
                    pickupPoints.push(pickupInfo);
                  }
                }
                let obj = {
                  routeID: this.routeID,
                  vehRegNo: vehRegNo,
                  pickupInfo: pickupPoints,
                  startLoc: { ...this.vehStartEndLoc[vehRegNo]['startLoc'] },
                  endLoc: { ...this.vehStartEndLoc[vehRegNo]['endLoc'] },
                }
                manyPickupPoints.push(obj);
              }
              setTimeout(() => {
                // console.log('save many pickup points',manyPickupPoints);
                this.api.addRouteAutoPickupPoint({ pickupData: manyPickupPoints }).then((res: any) => {
                  if (res.status == 'success') {
                    this.swal.swalFunction(res.status, res.status, res.message, 2000);
                    this.loader.hide();
                    this.generateBtnClicked = false;
                    this.closeProgressBar = true;
                    this.showProgress = false;
                    setTimeout(() => { this.getAutomaticPickupList(); }, 3000)
                  } else {
                    this.swal.swalFunction('error', res.status, res.message, 2000);
                    this.loader.hide();
                  }
                });
              }, 100);
            }
          }
        }
        else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
          this.loader.hide();
        }
      });
    }
    else {
      this.loader.hide();
    }
  }

  automaticRouteInput() {
    let vehicleObj = this.formObject['vehicle'].map((item) => {
      let vehObj = {
        id: this.allVehicles[item].vehRegNo,
        capacity: Number(this.allVehicles[item].capacity),
        start: {
          lat: this.vehStartEndLoc[item].startLoc.lat,
          lon: this.vehStartEndLoc[item].startLoc.lng,
        },
        end: {
          lat: this.vehStartEndLoc[item].endLoc.lat,
          lon: this.vehStartEndLoc[item].endLoc.lng,
        },
      };
      return vehObj;
    });
    let stopList = [];
    let employees = Object.values(this.automaticSelectedEmps);
    for (let e = 0; e < employees.length; e++) {
      let empObj = {
        id: `${employees[e]['employeeID']}$${new String(employees[e]['gender']).charAt(0).toUpperCase()}`,
        position: {
          lat: employees[e]['location']['lat'],
          lon: employees[e]['location']['lng'],
        },
        quantity: -1,
      }
      stopList.push(empObj);
    }
    let obj = {
      data: {
        defaults: {
          vehicles: {
            shift_start: this.getIsoTimeString(this.formObject.startTime),
            shift_end: this.getIsoTimeString(this.formObject.endTime),
            speed: 40
          },
          stops: {
            stop_duration: 120
          }
        },
        vehicles: vehicleObj,
        stops: stopList,
      },
      trasitMode: this.formObject.trasitMode,
      safeDrop: this.formObject.safeDrop,
    };
    return obj;
  }

  getEtaFromIsoTime(date) {
    let eta = new Date(date).toLocaleString().slice(12, 17);
    return eta;
  }
  getIsoTimeString(time) {
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let date = new Date().getDate();
    let [hr, min] = time.split(":");
    let returnString = new Date(`${year}-${month}-${date} ${hr}:${min}:00`).toISOString();
    return returnString;
  }
  // showing progress bar
  showProgressBar(currentValue, upcomingValue, msg?) {
    this.closeProgressBar = false;
    this.showProgress = true;
    setTimeout(() => {
      for (let i = currentValue; i <= upcomingValue; i++) {
        this.processValue = i;
        if (i == upcomingValue && msg) this.progressBarMsg = msg;
      }
    }, 2000);
  }

  processBarLabel(value: number) {
    if (value > 0) {
      let returnString = '';
      if (value < 20) { returnString = 'Processing'; }
      else if (value >= 20 && value < 39) {
        returnString = 'Processing employees location';
      } else if (value >= 40 && value < 59) {
        returnString = 'Processing vehicles location';
      } else if (value >= 60 && value < 79) {
        returnString = 'Processing pickup points';
      } else if (value >= 80 && value < 100) {
        returnString = 'Processing';
      } else if (value == 100) {
        returnString = 'Completed';
      }
      else {
        returnString = "processing...";
      }
      return returnString;
    }
    else return '';
  }

  async regenerateRoute() {

    if (this.addVehicleList.length > 0 && this.addVehicleEmployeeList.length > 0) {

      this.loader.show();
      let routeCreateObj = {
        transitMode: this.formObject.trasitMode,
        safeDrop: false,
      }
      let selectedVehicleForthisRoute = this.addVehicleList.map((item) => {

        return {
          vehRegNo: this.allVehicles[item].vehRegNo,
          CarName: this.allVehicles[item].vehRegNo,
          SeatCapacity: this.allVehicles[item].capacity,
          model: this.allVehicles[item].model,
          location: {
            lat: this.allVehicles[item]['location'].lat,
            lng: this.allVehicles[item]['location'].lng
          }
        };
      });
      routeCreateObj['cabInfo'] = selectedVehicleForthisRoute;
      routeCreateObj['employeeInfo'] = this.addVehicleEmployeeList;
      if (this.formObject.safeDrop) routeCreateObj['safeDrop'] = true;


      let returnObj = await this.routeservice.routeCreate([routeCreateObj]);
      this.automaticPickupInfo = returnObj['finalRoute'];
      this.setAutoVehiclePickup();
      this.unassingedEmps = returnObj['unAssignedEmp'];

      if (this.unassingedEmps.length > 0) {
        this.selectedEmpCounts = this.unassingedEmps.length;
        this.selectedFemaleEmpCounts = this.getFemaleEmpCount(this.unassingedEmps);
        setTimeout(() => { this.addUnassignedConfirmation(); }, 1000);
      }

    }

  }
  // set automatic pickup points
  getEta(previousEta, currentEta) {
    let [etaHour, etaMinute] = currentEta.split('.');
    if (etaMinute.length == 1) etaMinute = etaMinute + '0';
    let [stHour, stMinute] = previousEta.split(':');
    let today = new Date();
    let finalHour = Number(etaHour) + Number(stHour);
    let finalMinute = Number(etaMinute) + Number(stMinute);
    today.setHours(finalHour, finalMinute);
    return `${this.comservice.pad(today.getHours())}:${this.comservice.pad(today.getMinutes())}`
  }
  setAutoVehiclePickup() {
    if (this.automaticPickupInfo.length > 0) {
      this.automaticPickupInfo.filter((pickup) => {
        if (pickup.pickupInfo) {
          for (let p = 0; p < pickup.pickupInfo.length; p++) {
            if (p == 0) {
              pickup.pickupInfo[p]['eta'] = this.getEtaWithfromTime(this.routeData['startTimeStr'], pickup.pickupInfo[p]['eta']);
            }
            else {
              pickup.pickupInfo[p]['eta'] = this.getEtaWithfromTime(pickup.pickupInfo[p - 1]['eta'], pickup.pickupInfo[p]['eta']);
            }
            pickup.pickupInfo[p]['location'] = pickup.pickupInfo[p].locationName;
            pickup.pickupInfo[p]['radius'] = 1;
            pickup.pickupInfo[p]['tripStatus'] = 1;
            pickup.pickupInfo[p]['pickuppointStatus'] = 1;
          }
        }
      })
      //this.savePP();
    }
  }
  // combine duration with previous time so we can get Estimated time of arrival
  getEtaWithfromTime(previousTime, eta) {
    let [hour, minute] = previousTime.split(":");
    let [etaHr, etaMin] = eta.split(".");
    let finalDateTime = new Date().setHours(Number(hour) + Number(etaHr), Number(minute) + Number(etaMin));
    let result = `${this.comservice.pad(new Date(finalDateTime).getHours())}:${this.comservice.pad(new Date(finalDateTime).getMinutes())}`;
    return result;
  }
  // Save automatic pickup points
  savePP() {

    let pickupData = [];
    for (let veh = 0; veh < this.automaticPickupInfo.length; veh++) {
      let vehRegNo = this.automaticPickupInfo[veh]['cabInfo']['vehRegNo'];
      let obj = {
        routeID: this.routeID,
        vehRegNo: vehRegNo,
        pickupInfo: this.automaticPickupInfo[veh]['pickupInfo'],
        startLoc: { ...this.vehStartEndLoc[vehRegNo]['startLoc'] },
        endLoc: { ...this.vehStartEndLoc[vehRegNo]['endLoc'] },
      }
      pickupData.push(obj);
    }
    this.api.addRouteAutoPickupPoint({ pickupData: pickupData }).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        setTimeout(() => { this.getAutomaticPickupList(); }, 3000)
      } else {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }
  // Save start and end location In automatic route generation
  saveStEndLocation() {
    if (this.automaticPickupInfo.length > 0) {
      let successStEndLoc = true;
      for (let d = 0; d < this.automaticPickupInfo.length; d++) {
        if (this.automaticPickupInfo[d]['cabInfo']) {
          let vehRegNo = this.automaticPickupInfo[d]['cabInfo']['vehRegNo'];
          let obj = {
            routeID: this.routeID,
            vehRegNo: vehRegNo,
            startLoc: { ...this.vehStartEndLoc[vehRegNo]['startLoc'] },
            endLoc: { ...this.vehStartEndLoc[vehRegNo]['endLoc'] },
            duration: this.automaticPickupInfo[d].totalDuration ? this.automaticPickupInfo[d].totalDuration : '0',
            distance: this.automaticPickupInfo[d].distance ? this.automaticPickupInfo[d].distance : '0',
          }
          this.api.transportManagerRouteStEndLocCreate(obj).then((res: any) => {
            if (res.status == 'success') {
              // this.swal.swalFunction(res.status.toLowerCase(), res.status, res.message, 2000);
            } else {
              successStEndLoc = false;
              this.swal.swalFunction('error', res.status, res.message, 2000);
            }
          })
        }
        if (d == this.automaticPickupInfo.length - 1 && successStEndLoc) this.savePP();
      }
    }
  }
  // Save vehicle for automatic route creation
  saveRouteVehicle() {
    if (this.automaticPickupInfo.length > 0) {
      let vehicle = [];
      for (let d = 0; d < this.automaticPickupInfo.length; d++) {
        if (this.automaticPickupInfo[d]['cabInfo']) {
          vehicle.push(this.automaticPickupInfo[d]['cabInfo'].vehRegNo);
        }
      }
      if (vehicle.length > 0) {
        let obj = {
          routeID: this.routeID,
          vehicle: vehicle,
        }
        this.api.transportMangerRouteUpdate(obj).then((res: any) => {
          if (res.status == 'success') {
            // this.swal.swalFunction(res.status, res.status, res.message, 2000);
            this.routeData['vehicle'] = vehicle;
            this.saveStEndLocation();
          } else {
            this.swal.swalFunction('error', res.status, res.message, 2000);
          }
        });
      }
    }
  }
  removeVehConfimation(vehicle) {
    let fireContent = {
      title: 'Unassigned Vehicle!',
      icon: 'warning',
    };
    if (vehicle.length > 0) {
      let htmlContent = '';
      for (let r = 0; r < vehicle.length; r++) {
        htmlContent += `<tr><td class="border-top-0" style="font-size:16px;">${r + 1}</td><td class="border-top-0 text-left" style="font-size:16px;">${vehicle[r].toUpperCase()}</td></tr>`;
      }
      if (vehicle.length > 1) fireContent['title'] = 'Unassigned Vehicles!';
      fireContent['html'] = `<div class="row px-5">
                                  <h5 class="col-12 fw600">Selected more vehicles than employees,</h5>
                                  <h5 class="col-12 fw600">Excess vehicle will be removed.</h5>
                                  <div class="col-12" style="max-height:200px;overflow-y:auto;">
                                    <table class="table table-responsive table-sm"><tbody class="d-inline-flex">`+ htmlContent + `</tbody></table>
                                  </div>
                                </div>`;
      Swal.fire(fireContent).then((result) => {
        if (result.isConfirmed) {
          this.unassignedVehicles = [];
          this.saveRouteVehicle();
        }
      });
    }
    else {
      this.saveRouteVehicle();
    }
  }

  /* ------------------------------------------- */

  /* Form Validation */
  validation() {
    let objectKeys = Object.keys(this.formObject).filter(key => key != 'safeDrop');

    if (this.generalSetting == true) {
      objectKeys = Object.keys(this.formObject).filter(key => !['keywords', 'holidayPattern'].includes(key));
    }
    if (this.createAutoRoute && (this.formObject.vehicle == undefined || (Array.isArray(this.formObject.vehicle) && this.formObject.vehicle.length <= 0))) { objectKeys = objectKeys.filter(key => key != 'vehicle'); }
    let isValid = true;
    this.errorObject['invalidDate'] = '';
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
        if (key == 'routePpRadius') {
          this.errorObject[key] = 'Pickup Point Distance is required';
        }
        else if (key == 'dayCount') {
          this.errorObject[key] = 'Booking Day Count is required';
        }
        else this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      }
      else if ((key == 'fromDate' || key == 'toDate') && this.routeType == 'occasional') {
        if (new Date(this.formObject.fromDate).getTime() > new Date(this.formObject.toDate).getTime()) {
          isValid = false;
          this.errorObject['invalidDate'] = 'Invalid from date';
        }
      }
      else if (key == 'routePpRadius') {
        if (this.formObject.routePpRadius > 10 || this.formObject.routePpRadius < 0) {
          isValid = false;
          this.errorObject[key] = 'Value must be between 0 to 10'
        }
      }
      else if (key == 'dayCount') {
        if (this.formObject['bookingDays'] == 'multiple' && (0 >= this.formObject[key] || this.formObject[key] > 5)) {
          this.errorObject[key] = "Booking Day Count Range is 1 to 5";
          isValid = false;
        }
      }
    }
    return isValid;
  }

  /* Form action methods */
  //submit
  submitForm() {
    this.submitBtnPressed = true;
    this.formObject.routeType = this.routeType;
    let isValid = this.validation();
    if (isValid) {
      let notificationTypes = {};
      this.formObject.notification.filter((key) => {
        notificationTypes[key] = true;
      })

      let finalObj = { ...this.formObject };

      finalObj['fromDate'] = new Date(this.formObject['fromDate']).getTime();
      if (this.formObject['toDate']) finalObj['toDate'] = new Date(this.formObject['toDate']).getTime();
      finalObj.isEnable = parseInt(finalObj.isEnable);
      finalObj['notification'] = { ...notificationTypes };
      if (finalObj.dayCount) finalObj.dayCount = parseInt(finalObj.dayCount);

      let apiMethod = 'transportMangerRouteCreate';
      // if(this.routeType == 'openBooking'){
      //   apiMethod = 'transportManagerOpenBookingRouteCreate';
      // }
      this.api[apiMethod](finalObj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          if (this.createAutoRoute) {
            this.empPanelShow = true;
            this.enableAddEmployee = true;
            setTimeout(() => { this.panelExpandMore('empPanelExpand') }, 500);
          }
          this.router.navigate(['/organization/transport-manager/rostering/create-route', this.routeType, res.routeID]);
          // else this.router.navigate(['/organization/transport-manager/rostering/manage-route']);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      });
    }
  }
  //update
  // update unique field
  fieldChange(e: any, type, field) {
    let value: any;
    if (type == 'text' || type == 'textarea' || type == 'time') {
      if (this.generalSetting == true) {
        if (field == 'routePpRadius' && this.generalSetting == true) {
          value = e;
        }else if(type == 'text' && this.generalSetting == true && field == 'title'){
          value = e.target.value;
        } else if (type == 'time' && this.generalSetting == true && field == 'startTime') {
          value = e.target.value;
        }
        else if (type == 'time' && this.generalSetting == true && field == 'endTime') {
          value = e.target.value;
        } else if (type == 'dropdown' && this.generalSetting == true && field == 'notification') {
          value = e;
        } else if (type == 'dropdown' && this.generalSetting == true && field == 'attendence') {
          value = e;
        }
      }
      else {
        value = e.target.value;
      }
      if (field == 'dayCount') {
        value = parseInt(value);
      }
    }
    if (type == 'date') {
      if (e) value = new Date(e).getTime();
      else value = '';
    }
    if (type == 'dropdown' || type == 'radio') {
      if (field == 'vehicle' || field == 'holidayPattern' || field == 'branch' || field == 'shift') {
        value = e;
      } else if (field == 'notification') {
        value = {};
        if (this.generalSetting == true) {
        e.filter((key) => { value[key] = true; })
        }else{
          e.value.filter((key) => { value[key] = true; })
        }
      } else if (field == 'isEnable') {
        value = parseInt(e.value);
      }
      else {
        value = e.value;
      }
    }
    if (type == 'chipInput') {
      value = e;
    }
    if (type == 'checkbox') {
      value = e.checked;
    }
    if (this.submitBtnPressed) this.validation();
    if (this.routeEdit && field && (value != undefined)) this.updateField(field, value);
  }

  updateField(field, value) {
    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value, };
      this.updateValues = [
        ...filterUpdate,
        obj,
      ]
    }
    else {
      let obj = { field: field, value: value, };
      this.updateValues.push(obj);
    }
  }

  updateForm() {
    this.submitBtnPressed = true;
    this.formObject.routeType = this.routeType;
    let isValid = this.validation();
    if (isValid) {
      if (this.formObject.vehicle && this.formObject.vehicle.length > 0) {
        let checkObj = {
          routeStartTime: this.getDecimalTime(this.formObject.startTime),
          routeEndTime: this.getDecimalTime(this.formObject.endTime),
          fromDate: new Date(this.formObject.fromDate).getTime(),
          toDate: new Date(this.formObject.toDate).getTime(),
          vehicles: [...this.formObject.vehicle],
          routeID: this.routeID,
        }
        if (this.routeData['vehicle']) {
          checkObj.vehicles.filter((veh, index) => {
            if (this.routeData['vehicle'].includes(veh)) checkObj.vehicles.splice(index, 1);
          });
        }
        this.api.transportManagerEditRouteAvailableVeh(checkObj).then((res: any) => {

          if (res.status == 'success' && (res.data == undefined || res.data == '' || res.data.length < 0)) {
            const obj = { routeID: this.routeID, };
            if (this.updateValues.length > 0) {
              this.updateValues.filter((e) => { obj[e.field] = e.value; });
              this.checkUpdateRoute(obj);
            }
          }
          else if (res.status == 'success' && res.data != '' && Array.isArray(res.data) && res.data.length > 0) {
            this.existingAvailableVehConfirmation(res.data)
          }
        }).catch((err) => { console.log(err); });
      }
      else {
        if (this.updateValues.length > 0) {
          const obj = { routeID: this.routeID, };
          this.updateValues.filter((e) => { obj[e.field] = e.value; });
          this.checkUpdateRoute(obj);
        }
      }
    }
  }

  checkUpdateRoute(obj) {
    if ((obj.startTime || obj.endTime) && this.vehicleTableData.length > 0) {
      Swal.fire({
        title: 'Changing Time!',
        text: 'You need to change pickup point ETA manually.',
        icon: 'info',
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateRouteData(obj);
        }
      });
    }
    else this.updateRouteData(obj);
  }

  updateRouteData(obj) {
    let apiMethod = 'transportMangerRouteUpdate';
    if (obj['bookingDays'] == "monthly") {
      obj["dayCount"] = 'null';
    }
    this.api[apiMethod](obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.submitBtnPressed = false;
        this.updateValues = [];
        if (this.createAutoRoute) this.panelExpandMore('empPanelExpand');
        setTimeout(() => { this.getSelectedRoute(); }, 2500);
      } else {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    });
  }
  // Existing route vehicle popup 
  existingAvailableVehConfirmation(data) {
    console.log(data);
  }


  // cancel
  cancel() {
    let chekRouteExplore = this.storage.get('routeExploration');

    if (chekRouteExplore != undefined && chekRouteExplore != null && chekRouteExplore != '') {
      this.router.navigate(['organization/transport-manager/dashboard']);
    }
    else {
      if (!this.routeEdit && !this.createAutoRoute) this.router.navigate(['/organization/transport-manager/rostering/manage-route']);
      else this.formExpandLess();
    }
  }

  /* Vehicle Excel Download */

  //download excel
  async downloadVehExcel(vehRegNo) {
    try {
      this.loader.show();
      let vehicles = [];
      let startDate = new Date(new Date().setHours(0, 0, 0));
      let endDate = new Date();
      if (!Array.isArray(vehRegNo)) vehicles = [vehRegNo];
      else vehicles = vehRegNo;

      let pdata: any = [], excel = [];
      for (let veh = 0; veh < vehicles.length; veh++) {

        if (vehicles[veh] != undefined) {
          let responseRep = await this.getRouteWiseExlReport({ routeID: [this.routeID], vehRegNo: vehicles[veh] }).catch((err) => { console.log(err); });
          let apiData = responseRep[this.routeID];
          let tempData: any = await this.processExlData(apiData);
          excel = [...excel, ...tempData['xldata']];
          pdata = [...pdata, ...tempData['data']];
        }
      }
      if (excel.length > 0) {
        let showEmployee: boolean = false;
        let showGuest: boolean = false;
        let headerContent: any = ['S.No', 'Vehicle Reg No', 'Start Location', 'End Location', 'Duration', 'Distance', 'Pickup Point Name', 'Lat', 'Lng', 'Location', 'Radius (in Km)', 'ETA'];
        let sNo = 1;
        excel = excel.map((item) => {
          if (item.length > 11) showEmployee = true;
          if (item.length > 12) showGuest = true;
          item = [sNo, ...item];
          sNo++;
          return item;
        })
        if (showEmployee) headerContent = ['S.No', 'Vehicle Reg No', 'Start Location', 'End Location', 'Duration', 'Distance (in Km)', 'Pickup Point Name', 'Lat', 'Lng', 'Location', 'Radius (in Km)', 'ETA', 'Employee'];
        if (showGuest) headerContent = ['S.No', 'Vehicle Reg No', 'Start Location', 'End Location', 'Duration', 'Distance (in Km)', 'Pickup Point Name', 'Lat', 'Lng', 'Location', 'Radius (in Km)', 'ETA', 'Employee', 'Guest'];
        const excelInfo = {
          title: {
            title: 'Route Vehicle Report',
            // subTitleRow: 'Date : ' + this.comservice.timestampToDate(new Date(startDate).getTime(), 'DMY H:M:S') + ' to ' + this.comservice.timestampToDate(new Date(endDate).getTime(), 'DMY H:M:S'),
            font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
            mergeCells: 'A1:M2',
          },
          subtitle: {
            subTitleRow: [`Route Name  : ${this.routeData['title']} 
            From Date   : ${this.comservice.timestampToDate(new Date(this.routeData['fromDate']).getTime(), 'DMY H:M:S')}
            Start Time  : ${this.routeData['startTimeStr']}
            End Time    : ${this.routeData['endTimeStr']}
            Route Type  : ${this.routeData['buildType']}
            TransitMode : ${this.routeData['trasitMode']}`],
            font: { name: 'Corbel', family: 4, size: 12, },
            mergeCells: 'A3:M9'
          },
          header: {
            headers: headerContent,
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFFFFFFF' },
              bgColor: { argb: 'FFFFFFFF' }
            },
            border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
          },
          data: {
            data: excel,
            columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 30 }, { colNo: 4, width: 30 }, { colNo: 5, width: 15 }, { colNo: 6, width: 15 }, { colNo: 7, width: 20 }, { colNo: 8, width: 15 }, { colNo: 9, width: 15 }, { colNo: 10, width: 30 }, { colNo: 11, width: 15 }, { colNo: 11, width: 15 }, { colNo: 12, width: 15 }, { colNo: 13, width: 50 }]
          }
        };

        if (this.excelData['Route_Vehicle_Report'] == undefined) { this.excelData['Route_Vehicle_Report'] = {}; }
        this.excelData['Route_Vehicle_Report'] = excelInfo;
      }
      if (Object.keys(this.excelData).length > 0) {
        this.excel.generateExcel(this.excelData, 'Route_Vehicle_Report' + new Date().getTime() + '.xlsx');
      }
      this.loader.hide();
    } catch (err) {
      console.log(err);
    }

  }

  getRouteVehicleWiseExlReport(obj) {
    return new Promise((resolve, reject) => {
      try {
        this.api.transportManagerRouteVehicleWiseExlReport(obj).then((res: any) => {
          if (res.status == 'success') {
            console.log('before api res');
            resolve(res.data);
          }
          else resolve({});
        }).catch((err) => {
          console.log(err);
          resolve({});
        })
      } catch (err) {
        reject(err);
      }
    })
  }

  processExlData(data) {
    return new Promise((resolve, reject) => {
      try {
        if (data['ppInfo'] && data['ppInfo'].length > 0) {
          let processedData = [];
          let exlData = [];
          let enableEmp: boolean = false;
          let enableGuest: boolean = false;
          let results: any = data['ppInfo'].map((pp: any) => {
            let pPobj = { ...pp };
            try {
              if (pp.eta) {
                let eta = String(pp.eta).toLowerCase();
                let [hour, min]: any = eta.split(':');
                if (eta.includes('pm')) {
                  let val = eta.split(':');
                  hour = +val[0] + 12;
                  let [mins, meriden] = val[1].split(' ');
                  min = +mins;
                }
                let etaHrs = new Date(new Date().setHours(hour, min)).getHours();
                let etaMins = new Date(new Date().setHours(hour, min)).getMinutes();
                let finalEta = `${etaHrs}.${etaMins}`;
                pPobj['etaDecimal'] = Number.parseFloat(finalEta);
              }
              if (pp.assignedEmployees && pp.assignedEmployees.length > 0) enableEmp = true;
              if (pp.assignedGuest && pp.assignedGuest.length > 0) enableGuest = true;
            }
            catch (err) {
              console.log(err)
            }
            return pPobj;
          })
          results = results.sort((a, b) => a.etaDecimal - b.etaDecimal);

          results.map((item, index) => {
            const res = {
              vehRegNo: item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
              startLoc: data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['startLoc'] && data['locInfo'][0]['startLoc']['name'] ? this.comservice.convertTitleCase(data['locInfo'][0]['startLoc']['name']) : '---',
              endLoc: data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['endLoc'] && data['locInfo'][0]['endLoc']['name'] ? this.comservice.convertTitleCase(data['locInfo'][0]['endLoc']['name']) : '---',
              distance: data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['distance'] ? Math.floor(Math.abs(Number(data['locInfo'][0]['distance']))) : '---',
              duration: data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['duration'] ? this.decimalToTime(data['locInfo'][0]['duration']) : '--:--:--',
              title: item.title ? this.comservice.convertTitleCase(item.title) : '---',
              lat: item.lat ? item.lat : '---',
              lng: item.lng ? item.lng : '---',
              location: item.location ? this.comservice.convertTitleCase(item.location) : '---',
              radius: item.radius ? item.radius : '---',
              eta: item.eta ? item.eta : '---',
            };
            let rowVal = [res.vehRegNo, res.startLoc, res.endLoc, res.duration, res.distance, res.title, res.lat, res.lng, res.location, res.radius, res.eta];
            if (enableEmp) {
              if (item.assignedEmployees && item.assignedEmployees.length > 0) {
                let emps = item.assignedEmployees.map((emp) => {
                  let name = '---';
                  if (data['empInfo'] && Object.keys(data['empInfo']).length > 0 && data['empInfo'][emp] && data['empInfo'][emp]['name']) name = data['empInfo'][emp]['name'];
                  return name;
                })
                res['employee'] = emps.join(', ');
                rowVal.push(res['employee']);
              } else {
                res['employee'] = '---';
                rowVal.push(res['employee']);
              }
            }
            processedData.push(res);
            exlData.push(rowVal);
            if (index == results.length - 1) resolve({ data: processedData, xldata: exlData });
          })
        }
        else {
          resolve({ data: [], xldata: [] });
        }
      } catch (err) {
        console.log(err);
        reject(err);
      }
    })
  }

  async downloadRouteExcel(vehRegNo?, sheetName?) {
    try {
      this.excelData = {};
      let routeID = this.routeID
      this.loader.show();
      let exlSheetName = sheetName ? sheetName : 'Route_Report';
      let vehicles = [];
      let startDate = new Date(new Date().setHours(0, 0, 0));
      let endDate = new Date();
      let rowCount = 2;
      let responseRep = await this.getRouteWiseExlReport({ routeID: [routeID] }).catch((err) => { console.log(err); });
      let apiData = responseRep[routeID];
      let apiResKeys = Object.keys(apiData);
      if (apiResKeys.length > 1) {
        if (vehRegNo == '' || vehRegNo == undefined) vehicles = apiResKeys.filter(item => item != 'routeInfo');
        else vehicles = apiResKeys.filter(item => vehRegNo.includes(item));
      }
      // let vehRegNo = [];
      // if (!Array.isArray(vehRegNo)) vehicles = [vehRegNo];
      // else vehicles = vehRegNo;
      let pdata: any = [], excel = [], customizedData = [];

      let endCell = 'I';

      let titleRow = {
        value: ['Route Information'],
        font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(titleRow);

      rowCount = rowCount + 7;

      let exlRouteType = apiData['routeInfo']['routeType'] == 'openBooking' ? 'Open Booking' : this.comservice.convertTitleCase(apiData['routeInfo']['routeType']);
      exlRouteType = this.fieldMap.transform(exlRouteType, this.mappingField, ['route/rostering', 'menuButtons', apiData['routeInfo']['routeType'], 'name'])
      exlRouteType = this.comservice.convertTitleCase(exlRouteType);

      let subtitleRow = {
        value: ["Route Name  : " + this.comservice.convertTitleCase(apiData['routeInfo']['title']) + "\n" +
          "From Date     : " + this.comservice.timestampToDate(new Date(apiData['routeInfo']['fromDate']).getTime(), 'DMY') + "\n" +
          "Start Time     : " + apiData['routeInfo']['startTimeStr'] + "\n" +
          "End Time       : " + apiData['routeInfo']['endTimeStr'] + "\n" +
          "Route Type    : " + exlRouteType + "\n" +
          "Build Type    : " + apiData['routeInfo']['buildType'] + "\n" +
          "Transit Mode : " + apiData['routeInfo']['trasitMode'] + ""],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 6) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;

      let dividerRow = {
        value: [],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFFFF' }, //966462AF
          bgColor: { argb: 'FFFFFFFF' }
        },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }

      customizedData.push({ mergeCells: `A${rowCount + ''}:${endCell + rowCount + ''}`, ...dividerRow });

      rowCount = rowCount + 2;

      let vehicleTitle = {
        value: ['Vehicle Information'],
        font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(vehicleTitle);

      if (vehicles.length <= 0) {
        rowCount = rowCount + 1;
        let noDataRow =
        {
          value: ['No Vehicles'],
          mergeCells: `A${(rowCount) + ''}:${endCell + rowCount + ''}`,
          alignment: { cell: `A${(rowCount)}`, value: { vertical: 'middle', horizontal: 'center' } },
        }
        customizedData.push(noDataRow)
      }

      for (let veh = 0; veh < vehicles.length; veh++) {

        if (vehicles[veh] != undefined) {

          let tempData: any = await this.processRouteExlData(apiData[vehicles[veh]], vehicles[veh], endCell, rowCount);
          customizedData = [...customizedData, ...tempData['xlData']];
          rowCount = tempData['rowCount'];
          if (veh != vehicles.length - 1) {
            rowCount = rowCount + 1;
            let vehDivder = {
              value: [],
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFFFF' },
                bgColor: { argb: 'FFFFFFFF' }
              },
              border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
            }

            customizedData.push({ mergeCells: `A${rowCount + ''}:${endCell + rowCount + ''}`, ...vehDivder });
          }

        }
      }

      const customizedExlInfo = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 15 }, { colNo: 4, width: 15 }, { colNo: 5, width: 30 }, { colNo: 6, width: 15 }, { colNo: 7, width: 15 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }]
        }
      }
      if (this.excelData[exlSheetName] == undefined) { this.excelData[exlSheetName] = {}; }
      this.excelData[exlSheetName] = customizedExlInfo;
      if (Object.keys(this.excelData).length > 0) {
        this.excel.generateExcel(this.excelData, exlSheetName + new Date().getTime() + '.xlsx');
      }
      this.loader.hide();
    } catch (err) {
      console.log(err);
    }

  }

  getRouteWiseExlReport(obj) {
    return new Promise((resolve, reject) => {
      try {
        this.api.transportManagerRouteWiseExlReport(obj).then((res: any) => {
          if (res.status == 'success') {
            resolve(res.data);
          }
          else resolve({});
        }).catch((err) => {
          console.log(err);
          resolve({});
        })
      } catch (err) {
        reject(err);
      }
    })
  }

  processRouteExlData(data, vehRegNo, endCell, rowCount) {
    return new Promise((resolve, reject) => {
      try {
        let returnData = [];
        let exlData = [];
        let vehHeaderRow =
        {
          value: ['S.No', 'Pickup Point Name', 'Lat', 'Lng', 'Location', 'Radius (in Km)', 'ETA', 'Traveller Name', 'Traveller Type'],
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' },
            bgColor: { argb: 'FFFFFFFF' }
          },
          font: { bold: true },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        }
        if (data['locInfo']) {
          rowCount = rowCount + 5;
          let vehicleRow =
          {
            value: ["Vehicle Reg No    : " + (vehRegNo ? String(vehRegNo).toUpperCase() : '---') + "\n" +
              "Start Location      : " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['startLoc'] && data['locInfo'][0]['startLoc']['name'] ? this.comservice.convertTitleCase(data['locInfo'][0]['startLoc']['name']) : '---') + "\n" +
              "End Location       : " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['endLoc'] && data['locInfo'][0]['endLoc']['name'] ? this.comservice.convertTitleCase(data['locInfo'][0]['endLoc']['name']) : '---') + "\n" +
              "Distance (in Km)  :  " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['distance'] ? Math.floor(Math.abs(Number(data['locInfo'][0]['distance']))) : '---') + "\n" +
              "Duration               : " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['duration'] ? this.decimalToTime(data['locInfo'][0]['duration']) : '--:--:--') + ""
            ],
            font: { name: 'Corbel', family: 4, size: 12, },
            mergeCells: `A${(rowCount - 4) + ''}:${endCell + rowCount + ''}`,
          }
          returnData.push(vehicleRow);

          if (data['ppInfo'] && data['ppInfo'].length > 0) {

            let enableEmp: boolean = false;
            let enableGuest: boolean = false;
            let results: any = data['ppInfo'].map((pp: any) => {
              let pPobj = { ...pp };
              try {
                if (pp.eta) {
                  let eta = String(pp.eta).toLowerCase();
                  let [hour, min]: any = eta.split(':');
                  if (eta.includes('pm')) {
                    let val = eta.split(':');
                    hour = +val[0] + 12;
                    let [mins, meriden] = val[1].split(' ');
                    min = +mins;
                  }
                  let etaHrs = new Date(new Date().setHours(hour, min)).getHours();
                  let etaMins = new Date(new Date().setHours(hour, min)).getMinutes();
                  let finalEta = `${etaHrs}.${etaMins}`;
                  pPobj['etaDecimal'] = Number.parseFloat(finalEta);
                }
                if (pp.assignedEmployees && pp.assignedEmployees.length > 0) enableEmp = true;
                if (pp.assignedGuest && pp.assignedGuest.length > 0) enableGuest = true;
              }
              catch (err) {
                console.log(err)
              }
              return pPobj;
            })
            results = results.sort((a, b) => a.etaDecimal - b.etaDecimal);

            let rowCnt = rowCount + 2;
            results.map((item, index) => {
              let columnCount = 0;
              const res = {
                title: item.title ? this.comservice.convertTitleCase(item.title) : '---',
                lat: item.lat ? item.lat : '---',
                lng: item.lng ? item.lng : '---',
                location: item.location ? this.comservice.convertTitleCase(item.location) : '---',
                radius: item.radius ? item.radius : '---',
                eta: item.eta ? item.eta : '---',
                travellerType: '',
                travellers: ''
              };
              let multiRowVal = [{ value: [index + 1, res.title, res.lat, res.lng, res.location, res.radius, res.eta] }];
              if (enableEmp) {
                if (item.assignedEmployees && item.assignedEmployees.length > 0) {
                  let emps = item.assignedEmployees.map((emp) => {
                    let name = '--- - ---';
                    if (data['empInfo'] && Object.keys(data['empInfo']).length > 0 && data['empInfo'][emp]) {
                      if (data['empInfo'][emp]['name']) name = this.comservice.convertTitleCase(data['empInfo'][emp]['name']);
                      if (data['empInfo'][emp]['empRefID']) name = name + ' - ' + String(data['empInfo'][emp]['empRefID']).toUpperCase();
                    }
                    return name;
                  })
                  res['travellers'] = emps.join('\n');
                  emps.filter((emp) => {
                    if (res['travellerType'].length > 0) res['travellerType'] = res['travellerType'] + '\n' + 'Employee';
                    else res['travellerType'] = 'Employee';
                  })

                  columnCount = columnCount + emps.length;
                  multiRowVal[0]['value'].push(res['travellers'], res['travellerType']);
                }
              }
              if (enableGuest) {
                if (item.assignedGuest && item.assignedGuest.length > 0) {
                  let guests = item.assignedGuest.map((guest) => {
                    let name = '--- - ---';
                    if (data['guestInfo'] && Object.keys(data['guestInfo']).length > 0 && data['guestInfo'][guest]) {
                      if (data['guestInfo'][guest]['name']) name = this.comservice.convertTitleCase(data['guestInfo'][guest]['name']);
                      if (data['guestInfo'][guest]['userType']) name = name + ' - ' + this.comservice.convertTitleCase(data['guestInfo'][guest]['userType']);
                    }
                    return name;
                  })
                  if (res['travellers'].length > 0) res['travellers'] = res['travellers'] + '\n' + guests.join('\n');
                  else res['travellers'] = guests.join('\n');
                  guests.filter((guest) => {
                    if (res['travellerType'].length > 0) res['travellerType'] = res['travellerType'] + '\n' + 'Guest';
                    else res['travellerType'] = 'Guest';
                  })

                  columnCount = columnCount + guests.length;
                  multiRowVal[0]['value'][7] = res['travellers'];
                  multiRowVal[0]['value'][8] = res['travellerType'];
                }
              }
              if (columnCount >= 2) {
                multiRowVal[0]['mergeCells'] = [
                  `A${rowCnt}:A${rowCnt + columnCount - 1}`,
                  `B${rowCnt}:B${rowCnt + columnCount - 1}`,
                  `C${rowCnt}:C${rowCnt + columnCount - 1}`,
                  `D${rowCnt}:D${rowCnt + columnCount - 1}`,
                  `E${rowCnt}:E${rowCnt + columnCount - 1}`,
                  `F${rowCnt}:F${rowCnt + columnCount - 1}`,
                  `G${rowCnt}:G${rowCnt + columnCount - 1}`,
                  `H${rowCnt}:H${rowCnt + columnCount - 1}`,
                  `I${rowCnt}:I${rowCnt + columnCount - 1}`,
                ];
                multiRowVal[0]['alignment'] = [
                  { cell: `A${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `B${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `C${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `D${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `E${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `F${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `G${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `H${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `I${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },]
              }
              if (columnCount == 0) rowCnt = rowCnt + 1;
              rowCnt = rowCnt + columnCount;
              exlData = [...exlData, ...multiRowVal];
            });

            rowCount = rowCount + 1;

            returnData.push(vehHeaderRow);

            rowCount = rowCnt - 1;
            returnData = [...returnData, ...exlData];
            resolve({ rowCount: rowCount, xlData: returnData });
          }
          else {
            rowCount = rowCount + 1;
            returnData.push(vehHeaderRow);

            rowCount = rowCount + 1;
            let noDataRow =
            {
              value: ['No Pickup Points'],
              mergeCells: `A${(rowCount) + ''}:${endCell + rowCount + ''}`,
              alignment: { cell: `A${(rowCount)}`, value: { vertical: 'middle', horizontal: 'center' } },
            }
            returnData.push(noDataRow);

            resolve({ rowCount: rowCount, xlData: returnData });
          }
        }
        resolve({ rowCount: rowCount, xlData: returnData });
      } catch (err) {
        console.log(err);
        reject(err);
      }
    })
  }

  capitalizeWords(text: string): string {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

}
